window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.innerHTML="";
 linkmsg.style.visibility="hidden";
 sizemsg.style.visibility="hidden";
// opmsg.style.visibility="hidden";
}
//カート中身リセット
function cartReset(){
    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_haba.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color.innerHTML="";
//    cart_option.innerHTML="";
    linkmsg.style.visibility="hidden";
}
//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intHaba == ""){document.getElementById("inner_haba").innerHTML = "　";}
    if (intDepth == ""){document.getElementById("inner_depth").innerHTML = "　";}
    if (intHeight == ""){document.getElementById("inner_height").innerHTML = "　";}
    if (intHaba == ""){document.getElementById("longest").innerHTML = "　";}
    if (intDepth==""||intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intHaba < 90 || intHaba > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅90cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 30 || intDepth > 60){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行30cm未満・奥行61cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 30 || intHeight > 55){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ30cm未満・高さ56cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
    
    //小サイズ表示用
    var valueHaba = intHaba-4;
    var valueDepth = intDepth;
    var valueHeight = intHeight-14;
    var valueLongest = intHaba-8+valueHaba
    document.getElementById("inner_haba").innerHTML= "約"+valueHaba;
    document.getElementById("inner_depth").innerHTML= "約"+valueDepth;
    document.getElementById("inner_height").innerHTML= "約"+valueHeight;
    document.getElementById("longest").innerHTML= "約"+valueLongest;
    
 sizemsg.style.visibility="hidden";
}

/*function changeOp(){
    cartReset();
}*/

//サイズオーダー
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,color,price){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.color=color;this.price=price;}
function searchURL(strHaba,strDepth,strHeight,strColor){
var strErr;
var intHaba=document.getElementById("haba").value
var intDepth=document.getElementById("depth").value
var intHeight=document.getElementById("height").value

//サイズチェック
if (intHaba < 90 || intHaba > 180){strErr="幅90cm未満・幅181cm以上は";}
else if (intDepth < 30 || intDepth > 60){strErr="奥行30cm未満・奥行61cm以上は";}
else if (intHeight < 30 || intHeight > 55){strErr="高さ30cm未満・高さ56cm以上は";}
if(strErr){document.getElementById("price").value="";
return strErr+"オーダー不可です。";}

//幅サイズ成形
if (strHaba.slice(-1)>=1 && strHaba.slice(-1)<=5){strHaba=strHaba.slice(0,strHaba.length-1) +"5";}
else if (strHaba.slice(-1)>=6 && strHaba.slice(-1)<=9){strHaba=parseInt(strHaba.slice(0,strHaba.length-1)) + 1 +"0";}

//奥行サイズ成形
if (strDepth.slice(-1)>=1 && strDepth.slice(-1)<=5){strDepth=strDepth.slice(0,strDepth.length-1) +"5";}
else if (strDepth.slice(-1)>=6 && strDepth.slice(-1)<=9){strDepth=parseInt(strDepth.slice(0,strDepth.length-1)) + 1 +"0";}

//高さサイズ成形
switch(intHeight != null){
  case intHeight <= 30: //高さ30cm以下のとき
    strHeight = 30;
    break;
  case intHeight <= 45: //高さ45cm以下のとき
    strHeight = 45;
    break;
  case intHeight <= 50: //高さ50cm以下のとき
    strHeight = 50;
    break;
  case intHeight <= 55: //高さ55cm以下のとき
    strHeight = 55;
    break;
}

//ベース価格
var basePriceA = [36000,39000,42000,45000]; //化粧紙・aino
var basePriceB = [49000,54000,59000,64000]; //nail・black
var basePriceC = [52000,57000,62000,67000]; //bp
var basePriceD = [66000,71000,76000,81000]; //mb・gs・ww
var addPrice = [1000,3000,5000,8000];
var sellPrice;

var Column=(strHaba-90)/5;
var Row=(strDepth-30)/5;

if(strHeight == 30){//▼高さ30cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[0]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[0]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[0]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[0]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 45){//▼高さ31～45cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[1]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[1]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[1]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[1]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 50){//▼高さ46～50cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[2]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[2]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[2]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[2]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 55){//▼高さ51～55cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[3]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[3]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[3]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[3]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
 return sellPrice;
}


//リストから価格取得
/*function checkURL(strHaba,strDepth,strHeight,strColor){
switch(true){
  default:
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
console.log(goods[i].url+"/"+goods[i].price);
return goods[i].price;}}
  break; 
}
return false;
}*/
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strColor){
switch(true){
 default:
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("colortype") ;
//var idOption = document.getElementsByName("option") ;
var strColor = "";
//var strOption = "";
var strInner_haba = "";
var strInner_depth = "";
var strInner_height = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}
var total = 0;
/*for ( c = idOption.length; c--; ) {
 if ( idOption[c].checked ) {
     total++;
     if( strOption == "" ) {
         strOption = idOption[c].id;
         var valueOption = idOption[c].value;
     }else if( strOption != "" ) {
         var valueOption = valueOption+"、"+idOption[c].value;
     }
 }
}
if(typeof valueOption=== "undefined"){
     valueOption="オプション無し";
 }*/



if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueColor
//document.getElementById("choice5").value="オプション：" +valueOption+"/"
//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strColor);
//if (!comcode=="" && valueOption=="オプション無し"){
if(valueColor=="強化紙ブラックウッド"){
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML=valueColor+"は別注色のため既製品とは金額が異なります。";
}}
else if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strColor);

if(!url){
alert("幅、奥行を選んでください");
return false;
}

var intUnit;
if (isNaN(url)==false){
 if(total>0){
     total=total*3000;
 }
 intUnit=(parseInt(url)+total)/1000;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
// cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice5").value="見積もり金額："+(parseInt(url)+total);
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000a00061","90","40","42","wood","26400");
goods[1] =new setGoods("0000a57433","100","45","42","wood","30800");
goods[2] =new setGoods("0000a57440","110","45","42","wood","33000");
goods[3] =new setGoods("0000a57447","120","50","42","wood","37400");
goods[4] =new setGoods("0000a57454","130","55","42","wood","41800");
goods[5] =new setGoods("0000a57461","140","55","42","wood","44000");
goods[6] =new setGoods("0000a57468","150","60","42","wood","48400");
goods[7] =new setGoods("0000a57475","90","40","30","wood","24200");
goods[8] =new setGoods("0000a57482","100","45","30","wood","28600");
goods[9] =new setGoods("0000a57489","110","45","30","wood","30800");
goods[10] =new setGoods("0000a57496","120","50","30","wood","35200");
goods[11] =new setGoods("0000a57503","130","55","30","wood","39600");
goods[12] =new setGoods("0000a57510","140","55","30","wood","41800");
goods[13] =new setGoods("0000a57517","150","60","30","wood","46200");
goods[14] =new setGoods("0000a87009","90","30","30","wood","19800");
goods[15] =new setGoods("0000a87016","95","30","30","wood","20900");
goods[16] =new setGoods("0000a87023","100","30","30","wood","22000");
goods[17] =new setGoods("0000a87030","105","30","30","wood","23100");
goods[18] =new setGoods("0000a87037","110","30","30","wood","24200");
goods[19] =new setGoods("0000a87044","115","30","30","wood","25300");
goods[20] =new setGoods("0000a87051","120","30","30","wood","26400");
goods[21] =new setGoods("0000a87058","125","30","30","wood","27500");
goods[22] =new setGoods("0000a87065","130","30","30","wood","28600");
goods[23] =new setGoods("0000a87072","135","30","30","wood","29700");
goods[24] =new setGoods("0000a87079","140","30","30","wood","30800");
goods[25] =new setGoods("0000a87086","145","30","30","wood","31900");
goods[26] =new setGoods("0000a87093","150","30","30","wood","33000");
goods[27] =new setGoods("0000a87100","90","35","30","wood","22000");
goods[28] =new setGoods("0000a87107","95","35","30","wood","23100");
goods[29] =new setGoods("0000a87114","100","35","30","wood","24200");
goods[30] =new setGoods("0000a87121","105","35","30","wood","25300");
goods[31] =new setGoods("0000a87128","110","35","30","wood","26400");
goods[32] =new setGoods("0000a87135","115","35","30","wood","27500");
goods[33] =new setGoods("0000a87142","120","35","30","wood","28600");
goods[34] =new setGoods("0000a87149","125","35","30","wood","29700");
goods[35] =new setGoods("0000a87156","130","35","30","wood","30800");
goods[36] =new setGoods("0000a87163","135","35","30","wood","31900");
goods[37] =new setGoods("0000a87170","140","35","30","wood","33000");
goods[38] =new setGoods("0000a87177","145","35","30","wood","34100");
goods[39] =new setGoods("0000a87184","150","35","30","wood","35200");
goods[40] =new setGoods("0000a87191","95","40","30","wood","25300");
goods[41] =new setGoods("0000a87198","100","40","30","wood","26400");
goods[42] =new setGoods("0000a87205","105","40","30","wood","27500");
goods[43] =new setGoods("0000a87212","110","40","30","wood","28600");
goods[44] =new setGoods("0000a87219","115","40","30","wood","29700");
goods[45] =new setGoods("0000a87226","120","40","30","wood","30800");
goods[46] =new setGoods("0000a87233","125","40","30","wood","31900");
goods[47] =new setGoods("0000a87240","130","40","30","wood","33000");
goods[48] =new setGoods("0000a87247","135","40","30","wood","34100");
goods[49] =new setGoods("0000a87254","140","40","30","wood","35200");
goods[50] =new setGoods("0000a87261","145","40","30","wood","36300");
goods[51] =new setGoods("0000a87268","150","40","30","wood","37400");
goods[52] =new setGoods("0000a87275","90","45","30","wood","26400");
goods[53] =new setGoods("0000a87282","95","45","30","wood","27500");
goods[54] =new setGoods("0000a87289","105","45","30","wood","29700");
goods[55] =new setGoods("0000a87296","115","45","30","wood","31900");
goods[56] =new setGoods("0000a87303","120","45","30","wood","33000");
goods[57] =new setGoods("0000a87310","125","45","30","wood","34100");
goods[58] =new setGoods("0000a87317","130","45","30","wood","35200");
goods[59] =new setGoods("0000a87324","135","45","30","wood","36300");
goods[60] =new setGoods("0000a87331","140","45","30","wood","37400");
goods[61] =new setGoods("0000a87338","145","45","30","wood","38500");
goods[62] =new setGoods("0000a87345","150","45","30","wood","39600");
goods[63] =new setGoods("0000a87352","90","50","30","wood","28600");
goods[64] =new setGoods("0000a87359","95","50","30","wood","29700");
goods[65] =new setGoods("0000a87366","100","50","30","wood","30800");
goods[66] =new setGoods("0000a87373","105","50","30","wood","31900");
goods[67] =new setGoods("0000a87380","110","50","30","wood","33000");
goods[68] =new setGoods("0000a87387","115","50","30","wood","34100");
goods[69] =new setGoods("0000a87394","125","50","30","wood","36300");
goods[70] =new setGoods("0000a87401","130","50","30","wood","37400");
goods[71] =new setGoods("0000a87408","135","50","30","wood","38500");
goods[72] =new setGoods("0000a87415","140","50","30","wood","39600");
goods[73] =new setGoods("0000a87422","145","50","30","wood","40700");
goods[74] =new setGoods("0000a87429","150","50","30","wood","41800");
goods[75] =new setGoods("0000a87436","90","55","30","wood","30800");
goods[76] =new setGoods("0000a87443","95","55","30","wood","31900");
goods[77] =new setGoods("0000a87450","100","55","30","wood","33000");
goods[78] =new setGoods("0000a87457","105","55","30","wood","34100");
goods[79] =new setGoods("0000a87464","110","55","30","wood","35200");
goods[80] =new setGoods("0000a87471","115","55","30","wood","36300");
goods[81] =new setGoods("0000a87478","120","55","30","wood","37400");
goods[82] =new setGoods("0000a87485","125","55","30","wood","38500");
goods[83] =new setGoods("0000a87492","135","55","30","wood","40700");
goods[84] =new setGoods("0000a87499","145","55","30","wood","42900");
goods[85] =new setGoods("0000a87506","150","55","30","wood","44000");
goods[86] =new setGoods("0000a87513","90","60","30","wood","33000");
goods[87] =new setGoods("0000a87520","95","60","30","wood","34100");
goods[88] =new setGoods("0000a87527","100","60","30","wood","35200");
goods[89] =new setGoods("0000a87534","105","60","30","wood","36300");
goods[90] =new setGoods("0000a87541","110","60","30","wood","37400");
goods[91] =new setGoods("0000a87548","115","60","30","wood","38500");
goods[92] =new setGoods("0000a87555","120","60","30","wood","39600");
goods[93] =new setGoods("0000a87562","125","60","30","wood","40700");
goods[94] =new setGoods("0000a87569","130","60","30","wood","41800");
goods[95] =new setGoods("0000a87576","135","60","30","wood","42900");
goods[96] =new setGoods("0000a87583","140","60","30","wood","44000");
goods[97] =new setGoods("0000a87590","145","60","30","wood","45100");
goods[98] =new setGoods("0000a87597","90","30","42","wood","22000");
goods[99] =new setGoods("0000a87604","95","30","42","wood","23100");
goods[100] =new setGoods("0000a87611","100","30","42","wood","24200");
goods[101] =new setGoods("0000a87618","105","30","42","wood","25300");
goods[102] =new setGoods("0000a87625","110","30","42","wood","26400");
goods[103] =new setGoods("0000a87632","115","30","42","wood","27500");
goods[104] =new setGoods("0000a87639","120","30","42","wood","28600");
goods[105] =new setGoods("0000a87646","125","30","42","wood","29700");
goods[106] =new setGoods("0000a87653","130","30","42","wood","30800");
goods[107] =new setGoods("0000a87660","135","30","42","wood","31900");
goods[108] =new setGoods("0000a87667","140","30","42","wood","33000");
goods[109] =new setGoods("0000a87674","145","30","42","wood","34100");
goods[110] =new setGoods("0000a87681","150","30","42","wood","35200");
goods[111] =new setGoods("0000a87688","90","35","42","wood","24200");
goods[112] =new setGoods("0000a87695","95","35","42","wood","25300");
goods[113] =new setGoods("0000a87702","100","35","42","wood","26400");
goods[114] =new setGoods("0000a87709","105","35","42","wood","27500");
goods[115] =new setGoods("0000a87716","110","35","42","wood","28600");
goods[116] =new setGoods("0000a87723","115","35","42","wood","29700");
goods[117] =new setGoods("0000a87730","120","35","42","wood","30800");
goods[118] =new setGoods("0000a87737","125","35","42","wood","31900");
goods[119] =new setGoods("0000a87744","130","35","42","wood","33000");
goods[120] =new setGoods("0000a87751","135","35","42","wood","34100");
goods[121] =new setGoods("0000a87758","140","35","42","wood","35200");
goods[122] =new setGoods("0000a87765","145","35","42","wood","36300");
goods[123] =new setGoods("0000a87772","150","35","42","wood","37400");
goods[124] =new setGoods("0000a87779","95","40","42","wood","27500");
goods[125] =new setGoods("0000a87786","100","40","42","wood","28600");
goods[126] =new setGoods("0000a87793","105","40","42","wood","29700");
goods[127] =new setGoods("0000a87800","110","40","42","wood","30800");
goods[128] =new setGoods("0000a87807","115","40","42","wood","31900");
goods[129] =new setGoods("0000a87814","120","40","42","wood","33000");
goods[130] =new setGoods("0000a87821","125","40","42","wood","34100");
goods[131] =new setGoods("0000a87828","130","40","42","wood","35200");
goods[132] =new setGoods("0000a87835","135","40","42","wood","36300");
goods[133] =new setGoods("0000a87842","140","40","42","wood","37400");
goods[134] =new setGoods("0000a87849","145","40","42","wood","38500");
goods[135] =new setGoods("0000a87856","150","40","42","wood","39600");
goods[136] =new setGoods("0000a87863","90","45","42","wood","28600");
goods[137] =new setGoods("0000a87870","95","45","42","wood","29700");
goods[138] =new setGoods("0000a87877","105","45","42","wood","31900");
goods[139] =new setGoods("0000a87884","115","45","42","wood","34100");
goods[140] =new setGoods("0000a87891","120","45","42","wood","35200");
goods[141] =new setGoods("0000a87898","125","45","42","wood","36300");
goods[142] =new setGoods("0000a87905","130","45","42","wood","37400");
goods[143] =new setGoods("0000a87912","135","45","42","wood","38500");
goods[144] =new setGoods("0000a87919","140","45","42","wood","39600");
goods[145] =new setGoods("0000a87926","145","45","42","wood","40700");
goods[146] =new setGoods("0000a87933","150","45","42","wood","41800");
goods[147] =new setGoods("0000a87940","90","50","42","wood","30800");
goods[148] =new setGoods("0000a87947","95","50","42","wood","31900");
goods[149] =new setGoods("0000a87954","100","50","42","wood","33000");
goods[150] =new setGoods("0000a87961","105","50","42","wood","34100");
goods[151] =new setGoods("0000a87968","110","50","42","wood","35200");
goods[152] =new setGoods("0000a87975","115","50","42","wood","36300");
goods[153] =new setGoods("0000a87982","125","50","42","wood","38500");
goods[154] =new setGoods("0000a87989","130","50","42","wood","39600");
goods[155] =new setGoods("0000a87996","135","50","42","wood","40700");
goods[156] =new setGoods("0000a88003","140","50","42","wood","41800");
goods[157] =new setGoods("0000a88010","145","50","42","wood","42900");
goods[158] =new setGoods("0000a88017","150","50","42","wood","44000");
goods[159] =new setGoods("0000a88024","90","55","42","wood","33000");
goods[160] =new setGoods("0000a88031","95","55","42","wood","34100");
goods[161] =new setGoods("0000a88038","100","55","42","wood","35200");
goods[162] =new setGoods("0000a88045","105","55","42","wood","36300");
goods[163] =new setGoods("0000a88052","110","55","42","wood","37400");
goods[164] =new setGoods("0000a88059","115","55","42","wood","38500");
goods[165] =new setGoods("0000a88066","120","55","42","wood","39600");
goods[166] =new setGoods("0000a88073","125","55","42","wood","40700");
goods[167] =new setGoods("0000a88080","135","55","42","wood","42900");
goods[168] =new setGoods("0000a88087","145","55","42","wood","45100");
goods[169] =new setGoods("0000a88094","150","55","42","wood","46200");
goods[170] =new setGoods("0000a88101","90","60","42","wood","35200");
goods[171] =new setGoods("0000a88108","95","60","42","wood","36300");
goods[172] =new setGoods("0000a88115","100","60","42","wood","37400");
goods[173] =new setGoods("0000a88122","105","60","42","wood","38500");
goods[174] =new setGoods("0000a88129","110","60","42","wood","39600");
goods[175] =new setGoods("0000a88136","115","60","42","wood","40700");
goods[176] =new setGoods("0000a88143","120","60","42","wood","41800");
goods[177] =new setGoods("0000a88150","125","60","42","wood","42900");
goods[178] =new setGoods("0000a88157","130","60","42","wood","44000");
goods[179] =new setGoods("0000a88164","135","60","42","wood","45100");
goods[180] =new setGoods("0000a88171","140","60","42","wood","46200");
goods[181] =new setGoods("0000a88178","145","60","42","wood","47300");
goods[182] =new setGoods("0000a88185","90","30","50","wood","24200");
goods[183] =new setGoods("0000a88192","95","30","50","wood","25300");
goods[184] =new setGoods("0000a88199","100","30","50","wood","26400");
goods[185] =new setGoods("0000a88206","105","30","50","wood","27500");
goods[186] =new setGoods("0000a88213","110","30","50","wood","28600");
goods[187] =new setGoods("0000a88220","115","30","50","wood","29700");
goods[188] =new setGoods("0000a88227","120","30","50","wood","30800");
goods[189] =new setGoods("0000a88234","125","30","50","wood","31900");
goods[190] =new setGoods("0000a88241","130","30","50","wood","33000");
goods[191] =new setGoods("0000a88248","135","30","50","wood","34100");
goods[192] =new setGoods("0000a88255","140","30","50","wood","35200");
goods[193] =new setGoods("0000a88262","145","30","50","wood","36300");
goods[194] =new setGoods("0000a88269","150","30","50","wood","37400");
goods[195] =new setGoods("0000a88276","90","35","50","wood","26400");
goods[196] =new setGoods("0000a88283","95","35","50","wood","27500");
goods[197] =new setGoods("0000a88290","100","35","50","wood","28600");
goods[198] =new setGoods("0000a88297","105","35","50","wood","29700");
goods[199] =new setGoods("0000a88304","110","35","50","wood","30800");
goods[200] =new setGoods("0000a88311","115","35","50","wood","31900");
goods[201] =new setGoods("0000a88318","120","35","50","wood","33000");
goods[202] =new setGoods("0000a88325","125","35","50","wood","34100");
goods[203] =new setGoods("0000a88332","130","35","50","wood","35200");
goods[204] =new setGoods("0000a88339","135","35","50","wood","36300");
goods[205] =new setGoods("0000a88346","140","35","50","wood","37400");
goods[206] =new setGoods("0000a88353","145","35","50","wood","38500");
goods[207] =new setGoods("0000a88360","150","35","50","wood","39600");
goods[208] =new setGoods("0000a88367","90","40","50","wood","28600");
goods[209] =new setGoods("0000a88374","95","40","50","wood","29700");
goods[210] =new setGoods("0000a88381","100","40","50","wood","30800");
goods[211] =new setGoods("0000a88388","105","40","50","wood","31900");
goods[212] =new setGoods("0000a88395","110","40","50","wood","33000");
goods[213] =new setGoods("0000a88402","115","40","50","wood","34100");
goods[214] =new setGoods("0000a88409","120","40","50","wood","35200");
goods[215] =new setGoods("0000a88416","125","40","50","wood","36300");
goods[216] =new setGoods("0000a88423","130","40","50","wood","37400");
goods[217] =new setGoods("0000a88430","135","40","50","wood","38500");
goods[218] =new setGoods("0000a88437","140","40","50","wood","39600");
goods[219] =new setGoods("0000a88444","145","40","50","wood","40700");
goods[220] =new setGoods("0000a88451","150","40","50","wood","41800");
goods[221] =new setGoods("0000a88458","90","45","50","wood","30800");
goods[222] =new setGoods("0000a88465","95","45","50","wood","31900");
goods[223] =new setGoods("0000a88472","100","45","50","wood","33000");
goods[224] =new setGoods("0000a88479","105","45","50","wood","34100");
goods[225] =new setGoods("0000a88486","110","45","50","wood","35200");
goods[226] =new setGoods("0000a88493","115","45","50","wood","36300");
goods[227] =new setGoods("0000a88500","120","45","50","wood","37400");
goods[228] =new setGoods("0000a88507","125","45","50","wood","38500");
goods[229] =new setGoods("0000a88514","130","45","50","wood","39600");
goods[230] =new setGoods("0000a88521","135","45","50","wood","40700");
goods[231] =new setGoods("0000a88528","140","45","50","wood","41800");
goods[232] =new setGoods("0000a88535","145","45","50","wood","42900");
goods[233] =new setGoods("0000a88542","150","45","50","wood","44000");
goods[234] =new setGoods("0000a88549","90","50","50","wood","33000");
goods[235] =new setGoods("0000a88556","95","50","50","wood","34100");
goods[236] =new setGoods("0000a88563","100","50","50","wood","35200");
goods[237] =new setGoods("0000a88570","105","50","50","wood","36300");
goods[238] =new setGoods("0000a88577","110","50","50","wood","37400");
goods[239] =new setGoods("0000a88584","115","50","50","wood","38500");
goods[240] =new setGoods("0000a88591","120","50","50","wood","39600");
goods[241] =new setGoods("0000a88598","125","50","50","wood","40700");
goods[242] =new setGoods("0000a88605","130","50","50","wood","41800");
goods[243] =new setGoods("0000a88612","135","50","50","wood","42900");
goods[244] =new setGoods("0000a88619","140","50","50","wood","44000");
goods[245] =new setGoods("0000a88626","145","50","50","wood","45100");
goods[246] =new setGoods("0000a88633","150","50","50","wood","46200");
goods[247] =new setGoods("0000a88640","90","55","50","wood","35200");
goods[248] =new setGoods("0000a88647","95","55","50","wood","36300");
goods[249] =new setGoods("0000a88654","100","55","50","wood","37400");
goods[250] =new setGoods("0000a88661","105","55","50","wood","38500");
goods[251] =new setGoods("0000a88668","110","55","50","wood","39600");
goods[252] =new setGoods("0000a88675","115","55","50","wood","40700");
goods[253] =new setGoods("0000a88682","120","55","50","wood","41800");
goods[254] =new setGoods("0000a88689","125","55","50","wood","42900");
goods[255] =new setGoods("0000a88696","130","55","50","wood","44000");
goods[256] =new setGoods("0000a88703","135","55","50","wood","45100");
goods[257] =new setGoods("0000a88710","140","55","50","wood","46200");
goods[258] =new setGoods("0000a88717","145","55","50","wood","47300");
goods[259] =new setGoods("0000a88724","150","55","50","wood","48400");
goods[260] =new setGoods("0000a88731","90","60","50","wood","37400");
goods[261] =new setGoods("0000a88738","95","60","50","wood","38500");
goods[262] =new setGoods("0000a88745","100","60","50","wood","39600");
goods[263] =new setGoods("0000a88752","105","60","50","wood","40700");
goods[264] =new setGoods("0000a88759","110","60","50","wood","41800");
goods[265] =new setGoods("0000a88766","115","60","50","wood","42900");
goods[266] =new setGoods("0000a88773","120","60","50","wood","44000");
goods[267] =new setGoods("0000a88780","125","60","50","wood","45100");
goods[268] =new setGoods("0000a88787","130","60","50","wood","46200");
goods[269] =new setGoods("0000a88794","135","60","50","wood","47300");
goods[270] =new setGoods("0000a88801","140","60","50","wood","48400");
goods[271] =new setGoods("0000a88808","145","60","50","wood","49500");
goods[272] =new setGoods("0000a88815","150","60","50","wood","50600");
goods[273] =new setGoods("0000a39224","90","40","42","aino","26400");
goods[274] =new setGoods("0000a88822","90","30","30","aino","19800");
goods[275] =new setGoods("0000a88828","95","30","30","aino","20900");
goods[276] =new setGoods("0000a88834","100","30","30","aino","22000");
goods[277] =new setGoods("0000a88840","105","30","30","aino","23100");
goods[278] =new setGoods("0000a88846","110","30","30","aino","24200");
goods[279] =new setGoods("0000a88852","115","30","30","aino","25300");
goods[280] =new setGoods("0000a88858","120","30","30","aino","26400");
goods[281] =new setGoods("0000a88864","125","30","30","aino","27500");
goods[282] =new setGoods("0000a88870","130","30","30","aino","28600");
goods[283] =new setGoods("0000a88876","135","30","30","aino","29700");
goods[284] =new setGoods("0000a88882","140","30","30","aino","30800");
goods[285] =new setGoods("0000a88888","145","30","30","aino","31900");
goods[286] =new setGoods("0000a88894","150","30","30","aino","33000");
goods[287] =new setGoods("0000a88900","90","35","30","aino","22000");
goods[288] =new setGoods("0000a88906","95","35","30","aino","23100");
goods[289] =new setGoods("0000a88912","100","35","30","aino","24200");
goods[290] =new setGoods("0000a88918","105","35","30","aino","25300");
goods[291] =new setGoods("0000a88924","110","35","30","aino","26400");
goods[292] =new setGoods("0000a88930","115","35","30","aino","27500");
goods[293] =new setGoods("0000a88936","120","35","30","aino","28600");
goods[294] =new setGoods("0000a88942","125","35","30","aino","29700");
goods[295] =new setGoods("0000a88948","130","35","30","aino","30800");
goods[296] =new setGoods("0000a88954","135","35","30","aino","31900");
goods[297] =new setGoods("0000a88960","140","35","30","aino","33000");
goods[298] =new setGoods("0000a88966","145","35","30","aino","34100");
goods[299] =new setGoods("0000a88972","150","35","30","aino","35200");
goods[300] =new setGoods("0000a88978","90","40","30","aino","24200");
goods[301] =new setGoods("0000a88984","95","40","30","aino","25300");
goods[302] =new setGoods("0000a88990","100","40","30","aino","26400");
goods[303] =new setGoods("0000a88996","105","40","30","aino","27500");
goods[304] =new setGoods("0000a89002","110","40","30","aino","28600");
goods[305] =new setGoods("0000a89008","115","40","30","aino","29700");
goods[306] =new setGoods("0000a89014","120","40","30","aino","30800");
goods[307] =new setGoods("0000a89020","125","40","30","aino","31900");
goods[308] =new setGoods("0000a89026","130","40","30","aino","33000");
goods[309] =new setGoods("0000a89032","135","40","30","aino","34100");
goods[310] =new setGoods("0000a89038","140","40","30","aino","35200");
goods[311] =new setGoods("0000a89044","145","40","30","aino","36300");
goods[312] =new setGoods("0000a89050","150","40","30","aino","37400");
goods[313] =new setGoods("0000a89056","90","45","30","aino","26400");
goods[314] =new setGoods("0000a89062","95","45","30","aino","27500");
goods[315] =new setGoods("0000a89068","100","45","30","aino","28600");
goods[316] =new setGoods("0000a89074","105","45","30","aino","29700");
goods[317] =new setGoods("0000a89080","110","45","30","aino","30800");
goods[318] =new setGoods("0000a89086","115","45","30","aino","31900");
goods[319] =new setGoods("0000a89092","120","45","30","aino","33000");
goods[320] =new setGoods("0000a89098","125","45","30","aino","34100");
goods[321] =new setGoods("0000a89104","130","45","30","aino","35200");
goods[322] =new setGoods("0000a89110","135","45","30","aino","36300");
goods[323] =new setGoods("0000a89116","140","45","30","aino","37400");
goods[324] =new setGoods("0000a89122","145","45","30","aino","38500");
goods[325] =new setGoods("0000a89128","150","45","30","aino","39600");
goods[326] =new setGoods("0000a89134","90","50","30","aino","28600");
goods[327] =new setGoods("0000a89140","95","50","30","aino","29700");
goods[328] =new setGoods("0000a89146","100","50","30","aino","30800");
goods[329] =new setGoods("0000a89152","105","50","30","aino","31900");
goods[330] =new setGoods("0000a89158","110","50","30","aino","33000");
goods[331] =new setGoods("0000a89164","115","50","30","aino","34100");
goods[332] =new setGoods("0000a89170","120","50","30","aino","35200");
goods[333] =new setGoods("0000a89176","125","50","30","aino","36300");
goods[334] =new setGoods("0000a89182","130","50","30","aino","37400");
goods[335] =new setGoods("0000a89188","135","50","30","aino","38500");
goods[336] =new setGoods("0000a89194","140","50","30","aino","39600");
goods[337] =new setGoods("0000a89200","145","50","30","aino","40700");
goods[338] =new setGoods("0000a89206","150","50","30","aino","41800");
goods[339] =new setGoods("0000a89212","90","55","30","aino","30800");
goods[340] =new setGoods("0000a89218","95","55","30","aino","31900");
goods[341] =new setGoods("0000a89224","100","55","30","aino","33000");
goods[342] =new setGoods("0000a89230","105","55","30","aino","34100");
goods[343] =new setGoods("0000a89236","110","55","30","aino","35200");
goods[344] =new setGoods("0000a89242","115","55","30","aino","36300");
goods[345] =new setGoods("0000a89248","120","55","30","aino","37400");
goods[346] =new setGoods("0000a89254","125","55","30","aino","38500");
goods[347] =new setGoods("0000a89260","130","55","30","aino","39600");
goods[348] =new setGoods("0000a89266","135","55","30","aino","40700");
goods[349] =new setGoods("0000a89272","140","55","30","aino","41800");
goods[350] =new setGoods("0000a89278","145","55","30","aino","42900");
goods[351] =new setGoods("0000a89284","150","55","30","aino","44000");
goods[352] =new setGoods("0000a89290","90","60","30","aino","33000");
goods[353] =new setGoods("0000a89296","95","60","30","aino","34100");
goods[354] =new setGoods("0000a89302","100","60","30","aino","35200");
goods[355] =new setGoods("0000a89308","105","60","30","aino","36300");
goods[356] =new setGoods("0000a89314","110","60","30","aino","37400");
goods[357] =new setGoods("0000a89320","115","60","30","aino","38500");
goods[358] =new setGoods("0000a89326","120","60","30","aino","39600");
goods[359] =new setGoods("0000a89332","125","60","30","aino","40700");
goods[360] =new setGoods("0000a89338","130","60","30","aino","41800");
goods[361] =new setGoods("0000a89344","135","60","30","aino","42900");
goods[362] =new setGoods("0000a89350","140","60","30","aino","44000");
goods[363] =new setGoods("0000a89356","145","60","30","aino","45100");
goods[364] =new setGoods("0000a89362","150","60","30","aino","46200");
goods[365] =new setGoods("0000a89368","90","30","42","aino","19800");
goods[366] =new setGoods("0000a89374","95","30","42","aino","20900");
goods[367] =new setGoods("0000a89380","100","30","42","aino","22000");
goods[368] =new setGoods("0000a89386","105","30","42","aino","23100");
goods[369] =new setGoods("0000a89392","110","30","42","aino","24200");
goods[370] =new setGoods("0000a89398","115","30","42","aino","25300");
goods[371] =new setGoods("0000a89404","120","30","42","aino","26400");
goods[372] =new setGoods("0000a89410","125","30","42","aino","27500");
goods[373] =new setGoods("0000a89416","130","30","42","aino","28600");
goods[374] =new setGoods("0000a89422","135","30","42","aino","29700");
goods[375] =new setGoods("0000a89428","140","30","42","aino","30800");
goods[376] =new setGoods("0000a89434","145","30","42","aino","31900");
goods[377] =new setGoods("0000a89440","150","30","42","aino","33000");
goods[378] =new setGoods("0000a89446","90","35","42","aino","22000");
goods[379] =new setGoods("0000a89452","95","35","42","aino","23100");
goods[380] =new setGoods("0000a89458","100","35","42","aino","24200");
goods[381] =new setGoods("0000a89464","105","35","42","aino","25300");
goods[382] =new setGoods("0000a89470","110","35","42","aino","26400");
goods[383] =new setGoods("0000a89476","115","35","42","aino","27500");
goods[384] =new setGoods("0000a89482","120","35","42","aino","28600");
goods[385] =new setGoods("0000a89488","125","35","42","aino","29700");
goods[386] =new setGoods("0000a89494","130","35","42","aino","30800");
goods[387] =new setGoods("0000a89500","135","35","42","aino","31900");
goods[388] =new setGoods("0000a89506","140","35","42","aino","33000");
goods[389] =new setGoods("0000a89512","145","35","42","aino","34100");
goods[390] =new setGoods("0000a89518","150","35","42","aino","35200");
goods[391] =new setGoods("0000a89524","95","40","42","aino","25300");
goods[392] =new setGoods("0000a89530","100","40","42","aino","26400");
goods[393] =new setGoods("0000a89536","105","40","42","aino","27500");
goods[394] =new setGoods("0000a89542","110","40","42","aino","28600");
goods[395] =new setGoods("0000a89548","115","40","42","aino","29700");
goods[396] =new setGoods("0000a89554","120","40","42","aino","30800");
goods[397] =new setGoods("0000a89560","125","40","42","aino","31900");
goods[398] =new setGoods("0000a89566","130","40","42","aino","33000");
goods[399] =new setGoods("0000a89572","135","40","42","aino","34100");
goods[400] =new setGoods("0000a89578","140","40","42","aino","35200");
goods[401] =new setGoods("0000a89584","145","40","42","aino","36300");
goods[402] =new setGoods("0000a89590","150","40","42","aino","37400");
goods[403] =new setGoods("0000a89596","90","45","42","aino","26400");
goods[404] =new setGoods("0000a89602","95","45","42","aino","27500");
goods[405] =new setGoods("0000a89608","100","45","42","aino","28600");
goods[406] =new setGoods("0000a89614","105","45","42","aino","29700");
goods[407] =new setGoods("0000a89620","110","45","42","aino","30800");
goods[408] =new setGoods("0000a89626","115","45","42","aino","31900");
goods[409] =new setGoods("0000a89632","120","45","42","aino","33000");
goods[410] =new setGoods("0000a89638","125","45","42","aino","34100");
goods[411] =new setGoods("0000a89644","130","45","42","aino","35200");
goods[412] =new setGoods("0000a89650","135","45","42","aino","36300");
goods[413] =new setGoods("0000a89656","140","45","42","aino","37400");
goods[414] =new setGoods("0000a89662","145","45","42","aino","38500");
goods[415] =new setGoods("0000a89668","150","45","42","aino","39600");
goods[416] =new setGoods("0000a89674","90","50","42","aino","28600");
goods[417] =new setGoods("0000a89680","95","50","42","aino","29700");
goods[418] =new setGoods("0000a89686","100","50","42","aino","30800");
goods[419] =new setGoods("0000a89692","105","50","42","aino","31900");
goods[420] =new setGoods("0000a89698","110","50","42","aino","33000");
goods[421] =new setGoods("0000a89704","115","50","42","aino","34100");
goods[422] =new setGoods("0000a89710","120","50","42","aino","35200");
goods[423] =new setGoods("0000a89716","125","50","42","aino","36300");
goods[424] =new setGoods("0000a89722","130","50","42","aino","37400");
goods[425] =new setGoods("0000a89728","135","50","42","aino","38500");
goods[426] =new setGoods("0000a89734","140","50","42","aino","39600");
goods[427] =new setGoods("0000a89740","145","50","42","aino","40700");
goods[428] =new setGoods("0000a89746","150","50","42","aino","41800");
goods[429] =new setGoods("0000a89752","90","55","42","aino","30800");
goods[430] =new setGoods("0000a89758","95","55","42","aino","31900");
goods[431] =new setGoods("0000a89764","100","55","42","aino","33000");
goods[432] =new setGoods("0000a89770","105","55","42","aino","34100");
goods[433] =new setGoods("0000a89776","110","55","42","aino","35200");
goods[434] =new setGoods("0000a89782","115","55","42","aino","36300");
goods[435] =new setGoods("0000a89788","120","55","42","aino","37400");
goods[436] =new setGoods("0000a89794","125","55","42","aino","38500");
goods[437] =new setGoods("0000a89800","130","55","42","aino","39600");
goods[438] =new setGoods("0000a89806","135","55","42","aino","40700");
goods[439] =new setGoods("0000a89812","140","55","42","aino","41800");
goods[440] =new setGoods("0000a89818","145","55","42","aino","42900");
goods[441] =new setGoods("0000a89824","150","55","42","aino","44000");
goods[442] =new setGoods("0000a89830","90","60","42","aino","33000");
goods[443] =new setGoods("0000a89836","95","60","42","aino","34100");
goods[444] =new setGoods("0000a89842","100","60","42","aino","35200");
goods[445] =new setGoods("0000a89848","105","60","42","aino","36300");
goods[446] =new setGoods("0000a89854","110","60","42","aino","37400");
goods[447] =new setGoods("0000a89860","115","60","42","aino","38500");
goods[448] =new setGoods("0000a89866","120","60","42","aino","39600");
goods[449] =new setGoods("0000a89872","125","60","42","aino","40700");
goods[450] =new setGoods("0000a89878","130","60","42","aino","41800");
goods[451] =new setGoods("0000a89884","135","60","42","aino","42900");
goods[452] =new setGoods("0000a89890","140","60","42","aino","44000");
goods[453] =new setGoods("0000a89896","145","60","42","aino","45100");
goods[454] =new setGoods("0000a89902","150","60","42","aino","46200");
goods[455] =new setGoods("0000a89908","90","30","50","aino","24200");
goods[456] =new setGoods("0000a89914","95","30","50","aino","25300");
goods[457] =new setGoods("0000a89920","100","30","50","aino","26400");
goods[458] =new setGoods("0000a89926","105","30","50","aino","27500");
goods[459] =new setGoods("0000a89932","110","30","50","aino","28600");
goods[460] =new setGoods("0000a89938","115","30","50","aino","29700");
goods[461] =new setGoods("0000a89944","120","30","50","aino","30800");
goods[462] =new setGoods("0000a89950","125","30","50","aino","31900");
goods[463] =new setGoods("0000a89956","130","30","50","aino","33000");
goods[464] =new setGoods("0000a89962","135","30","50","aino","34100");
goods[465] =new setGoods("0000a89968","140","30","50","aino","35200");
goods[466] =new setGoods("0000a89974","145","30","50","aino","36300");
goods[467] =new setGoods("0000a89980","150","30","50","aino","37400");
goods[468] =new setGoods("0000a89986","90","35","50","aino","26400");
goods[469] =new setGoods("0000a89992","95","35","50","aino","27500");
goods[470] =new setGoods("0000a89998","100","35","50","aino","28600");
goods[471] =new setGoods("0000a90004","105","35","50","aino","29700");
goods[472] =new setGoods("0000a90010","110","35","50","aino","30800");
goods[473] =new setGoods("0000a90016","115","35","50","aino","31900");
goods[474] =new setGoods("0000a90022","120","35","50","aino","33000");
goods[475] =new setGoods("0000a90028","125","35","50","aino","34100");
goods[476] =new setGoods("0000a90034","130","35","50","aino","35200");
goods[477] =new setGoods("0000a90040","135","35","50","aino","36300");
goods[478] =new setGoods("0000a90046","140","35","50","aino","37400");
goods[479] =new setGoods("0000a90052","145","35","50","aino","38500");
goods[480] =new setGoods("0000a90058","150","35","50","aino","39600");
goods[481] =new setGoods("0000a90064","90","40","50","aino","28600");
goods[482] =new setGoods("0000a90070","95","40","50","aino","29700");
goods[483] =new setGoods("0000a90076","100","40","50","aino","30800");
goods[484] =new setGoods("0000a90082","105","40","50","aino","31900");
goods[485] =new setGoods("0000a90088","110","40","50","aino","33000");
goods[486] =new setGoods("0000a90094","115","40","50","aino","34100");
goods[487] =new setGoods("0000a90100","120","40","50","aino","35200");
goods[488] =new setGoods("0000a90106","125","40","50","aino","36300");
goods[489] =new setGoods("0000a90112","130","40","50","aino","37400");
goods[490] =new setGoods("0000a90118","135","40","50","aino","38500");
goods[491] =new setGoods("0000a90124","140","40","50","aino","39600");
goods[492] =new setGoods("0000a90130","145","40","50","aino","40700");
goods[493] =new setGoods("0000a90136","150","40","50","aino","41800");
goods[494] =new setGoods("0000a90142","90","45","50","aino","30800");
goods[495] =new setGoods("0000a90148","95","45","50","aino","31900");
goods[496] =new setGoods("0000a90154","100","45","50","aino","33000");
goods[497] =new setGoods("0000a90160","105","45","50","aino","34100");
goods[498] =new setGoods("0000a90166","110","45","50","aino","35200");
goods[499] =new setGoods("0000a90172","115","45","50","aino","36300");
goods[500] =new setGoods("0000a90178","120","45","50","aino","37400");
goods[501] =new setGoods("0000a90184","125","45","50","aino","38500");
goods[502] =new setGoods("0000a90190","130","45","50","aino","39600");
goods[503] =new setGoods("0000a90196","135","45","50","aino","40700");
goods[504] =new setGoods("0000a90202","140","45","50","aino","41800");
goods[505] =new setGoods("0000a90208","145","45","50","aino","42900");
goods[506] =new setGoods("0000a90214","150","45","50","aino","44000");
goods[507] =new setGoods("0000a90220","90","50","50","aino","33000");
goods[508] =new setGoods("0000a90226","95","50","50","aino","34100");
goods[509] =new setGoods("0000a90232","100","50","50","aino","35200");
goods[510] =new setGoods("0000a90238","105","50","50","aino","36300");
goods[511] =new setGoods("0000a90244","110","50","50","aino","37400");
goods[512] =new setGoods("0000a90250","115","50","50","aino","38500");
goods[513] =new setGoods("0000a90256","120","50","50","aino","39600");
goods[514] =new setGoods("0000a90262","125","50","50","aino","40700");
goods[515] =new setGoods("0000a90268","130","50","50","aino","41800");
goods[516] =new setGoods("0000a90274","135","50","50","aino","42900");
goods[517] =new setGoods("0000a90280","140","50","50","aino","44000");
goods[518] =new setGoods("0000a90286","145","50","50","aino","45100");
goods[519] =new setGoods("0000a90292","150","50","50","aino","46200");
goods[520] =new setGoods("0000a90298","90","55","50","aino","35200");
goods[521] =new setGoods("0000a90304","95","55","50","aino","36300");
goods[522] =new setGoods("0000a90310","100","55","50","aino","37400");
goods[523] =new setGoods("0000a90316","105","55","50","aino","38500");
goods[524] =new setGoods("0000a90322","110","55","50","aino","39600");
goods[525] =new setGoods("0000a90328","115","55","50","aino","40700");
goods[526] =new setGoods("0000a90334","120","55","50","aino","41800");
goods[527] =new setGoods("0000a90340","125","55","50","aino","42900");
goods[528] =new setGoods("0000a90346","130","55","50","aino","44000");
goods[529] =new setGoods("0000a90352","135","55","50","aino","45100");
goods[530] =new setGoods("0000a90358","140","55","50","aino","46200");
goods[531] =new setGoods("0000a90364","145","55","50","aino","47300");
goods[532] =new setGoods("0000a90370","150","55","50","aino","48400");
goods[533] =new setGoods("0000a90376","90","60","50","aino","37400");
goods[534] =new setGoods("0000a90382","95","60","50","aino","38500");
goods[535] =new setGoods("0000a90388","100","60","50","aino","39600");
goods[536] =new setGoods("0000a90394","105","60","50","aino","40700");
goods[537] =new setGoods("0000a90400","110","60","50","aino","41800");
goods[538] =new setGoods("0000a90406","115","60","50","aino","42900");
goods[539] =new setGoods("0000a90412","120","60","50","aino","44000");
goods[540] =new setGoods("0000a90418","125","60","50","aino","45100");
goods[541] =new setGoods("0000a90424","130","60","50","aino","46200");
goods[542] =new setGoods("0000a90430","135","60","50","aino","47300");
goods[543] =new setGoods("0000a90436","140","60","50","aino","48400");
goods[544] =new setGoods("0000a90442","145","60","50","aino","49500");
goods[545] =new setGoods("0000a90448","150","60","50","aino","50600");
goods[546] =new setGoods("0000a90454","90","30","30","nail","31900");
goods[547] =new setGoods("0000a90455","95","30","30","nail","33000");
goods[548] =new setGoods("0000a90456","100","30","30","nail","34100");
goods[549] =new setGoods("0000a90457","105","30","30","nail","35200");
goods[550] =new setGoods("0000a90458","110","30","30","nail","36300");
goods[551] =new setGoods("0000a90459","115","30","30","nail","37400");
goods[552] =new setGoods("0000a90460","120","30","30","nail","38500");
goods[553] =new setGoods("0000a90461","125","30","30","nail","39600");
goods[554] =new setGoods("0000a90462","130","30","30","nail","40700");
goods[555] =new setGoods("0000a90463","135","30","30","nail","41800");
goods[556] =new setGoods("0000a90464","140","30","30","nail","42900");
goods[557] =new setGoods("0000a90465","145","30","30","nail","44000");
goods[558] =new setGoods("0000a90466","150","30","30","nail","45100");
goods[559] =new setGoods("0000a90467","90","35","30","nail","36300");
goods[560] =new setGoods("0000a90468","95","35","30","nail","37400");
goods[561] =new setGoods("0000a90469","100","35","30","nail","38500");
goods[562] =new setGoods("0000a90470","105","35","30","nail","39600");
goods[563] =new setGoods("0000a90471","110","35","30","nail","40700");
goods[564] =new setGoods("0000a90472","115","35","30","nail","41800");
goods[565] =new setGoods("0000a90473","120","35","30","nail","42900");
goods[566] =new setGoods("0000a90474","125","35","30","nail","44000");
goods[567] =new setGoods("0000a90475","130","35","30","nail","45100");
goods[568] =new setGoods("0000a90476","135","35","30","nail","46200");
goods[569] =new setGoods("0000a90477","140","35","30","nail","47300");
goods[570] =new setGoods("0000a90478","145","35","30","nail","48400");
goods[571] =new setGoods("0000a90479","150","35","30","nail","49500");
goods[572] =new setGoods("0000a90480","90","40","30","nail","40700");
goods[573] =new setGoods("0000a90481","95","40","30","nail","41800");
goods[574] =new setGoods("0000a90482","100","40","30","nail","42900");
goods[575] =new setGoods("0000a90483","105","40","30","nail","44000");
goods[576] =new setGoods("0000a90484","110","40","30","nail","45100");
goods[577] =new setGoods("0000a90485","115","40","30","nail","46200");
goods[578] =new setGoods("0000a90486","120","40","30","nail","47300");
goods[579] =new setGoods("0000a90487","125","40","30","nail","48400");
goods[580] =new setGoods("0000a90488","130","40","30","nail","49500");
goods[581] =new setGoods("0000a90489","135","40","30","nail","50600");
goods[582] =new setGoods("0000a90490","140","40","30","nail","51700");
goods[583] =new setGoods("0000a90491","145","40","30","nail","52800");
goods[584] =new setGoods("0000a90492","150","40","30","nail","53900");
goods[585] =new setGoods("0000a90493","90","45","30","nail","45100");
goods[586] =new setGoods("0000a90494","95","45","30","nail","46200");
goods[587] =new setGoods("0000a90495","100","45","30","nail","47300");
goods[588] =new setGoods("0000a90496","105","45","30","nail","48400");
goods[589] =new setGoods("0000a90497","110","45","30","nail","49500");
goods[590] =new setGoods("0000a90498","115","45","30","nail","50600");
goods[591] =new setGoods("0000a90499","120","45","30","nail","51700");
goods[592] =new setGoods("0000a90500","125","45","30","nail","52800");
goods[593] =new setGoods("0000a90501","130","45","30","nail","53900");
goods[594] =new setGoods("0000a90502","135","45","30","nail","55000");
goods[595] =new setGoods("0000a90503","140","45","30","nail","56100");
goods[596] =new setGoods("0000a90504","145","45","30","nail","57200");
goods[597] =new setGoods("0000a90505","150","45","30","nail","58300");
goods[598] =new setGoods("0000a90506","90","50","30","nail","49500");
goods[599] =new setGoods("0000a90507","95","50","30","nail","50600");
goods[600] =new setGoods("0000a90508","100","50","30","nail","51700");
goods[601] =new setGoods("0000a90509","105","50","30","nail","52800");
goods[602] =new setGoods("0000a90510","110","50","30","nail","53900");
goods[603] =new setGoods("0000a90511","115","50","30","nail","55000");
goods[604] =new setGoods("0000a90512","120","50","30","nail","56100");
goods[605] =new setGoods("0000a90513","125","50","30","nail","57200");
goods[606] =new setGoods("0000a90514","130","50","30","nail","58300");
goods[607] =new setGoods("0000a90515","135","50","30","nail","59400");
goods[608] =new setGoods("0000a90516","140","50","30","nail","60500");
goods[609] =new setGoods("0000a90517","145","50","30","nail","61600");
goods[610] =new setGoods("0000a90518","150","50","30","nail","62700");
goods[611] =new setGoods("0000a90519","90","55","30","nail","53900");
goods[612] =new setGoods("0000a90520","95","55","30","nail","55000");
goods[613] =new setGoods("0000a90521","100","55","30","nail","56100");
goods[614] =new setGoods("0000a90522","105","55","30","nail","57200");
goods[615] =new setGoods("0000a90523","110","55","30","nail","58300");
goods[616] =new setGoods("0000a90524","115","55","30","nail","59400");
goods[617] =new setGoods("0000a90525","120","55","30","nail","60500");
goods[618] =new setGoods("0000a90526","125","55","30","nail","61600");
goods[619] =new setGoods("0000a90527","130","55","30","nail","62700");
goods[620] =new setGoods("0000a90528","135","55","30","nail","63800");
goods[621] =new setGoods("0000a90529","140","55","30","nail","64900");
goods[622] =new setGoods("0000a90530","145","55","30","nail","66000");
goods[623] =new setGoods("0000a90531","150","55","30","nail","67100");
goods[624] =new setGoods("0000a90532","90","60","30","nail","58300");
goods[625] =new setGoods("0000a90533","95","60","30","nail","59400");
goods[626] =new setGoods("0000a90534","100","60","30","nail","60500");
goods[627] =new setGoods("0000a90535","105","60","30","nail","61600");
goods[628] =new setGoods("0000a90536","110","60","30","nail","62700");
goods[629] =new setGoods("0000a90537","115","60","30","nail","63800");
goods[630] =new setGoods("0000a90538","120","60","30","nail","64900");
goods[631] =new setGoods("0000a90539","125","60","30","nail","66000");
goods[632] =new setGoods("0000a90540","130","60","30","nail","67100");
goods[633] =new setGoods("0000a90541","135","60","30","nail","68200");
goods[634] =new setGoods("0000a90542","140","60","30","nail","69300");
goods[635] =new setGoods("0000a90543","145","60","30","nail","70400");
goods[636] =new setGoods("0000a90544","150","60","30","nail","71500");
goods[637] =new setGoods("0000a90545","90","30","42","nail","37400");
goods[638] =new setGoods("0000a90546","95","30","42","nail","38500");
goods[639] =new setGoods("0000a90547","100","30","42","nail","39600");
goods[640] =new setGoods("0000a90548","105","30","42","nail","40700");
goods[641] =new setGoods("0000a90549","110","30","42","nail","41800");
goods[642] =new setGoods("0000a90550","115","30","42","nail","42900");
goods[643] =new setGoods("0000a90551","120","30","42","nail","44000");
goods[644] =new setGoods("0000a90552","125","30","42","nail","45100");
goods[645] =new setGoods("0000a90553","130","30","42","nail","46200");
goods[646] =new setGoods("0000a90554","135","30","42","nail","47300");
goods[647] =new setGoods("0000a90555","140","30","42","nail","48400");
goods[648] =new setGoods("0000a90556","145","30","42","nail","49500");
goods[649] =new setGoods("0000a90557","150","30","42","nail","50600");
goods[650] =new setGoods("0000a90558","90","35","42","nail","41800");
goods[651] =new setGoods("0000a90559","95","35","42","nail","42900");
goods[652] =new setGoods("0000a90560","100","35","42","nail","44000");
goods[653] =new setGoods("0000a90561","105","35","42","nail","45100");
goods[654] =new setGoods("0000a90562","110","35","42","nail","46200");
goods[655] =new setGoods("0000a90563","115","35","42","nail","47300");
goods[656] =new setGoods("0000a90564","120","35","42","nail","48400");
goods[657] =new setGoods("0000a90565","125","35","42","nail","49500");
goods[658] =new setGoods("0000a90566","130","35","42","nail","50600");
goods[659] =new setGoods("0000a90567","135","35","42","nail","51700");
goods[660] =new setGoods("0000a90568","140","35","42","nail","52800");
goods[661] =new setGoods("0000a90569","145","35","42","nail","53900");
goods[662] =new setGoods("0000a90570","150","35","42","nail","55000");
goods[663] =new setGoods("0000a90571","90","40","42","nail","46200");
goods[664] =new setGoods("0000a90572","95","40","42","nail","47300");
goods[665] =new setGoods("0000a90573","100","40","42","nail","48400");
goods[666] =new setGoods("0000a90574","105","40","42","nail","49500");
goods[667] =new setGoods("0000a90575","110","40","42","nail","50600");
goods[668] =new setGoods("0000a90576","115","40","42","nail","51700");
goods[669] =new setGoods("0000a90577","120","40","42","nail","52800");
goods[670] =new setGoods("0000a90578","125","40","42","nail","53900");
goods[671] =new setGoods("0000a90579","130","40","42","nail","55000");
goods[672] =new setGoods("0000a90580","135","40","42","nail","56100");
goods[673] =new setGoods("0000a90581","140","40","42","nail","57200");
goods[674] =new setGoods("0000a90582","145","40","42","nail","58300");
goods[675] =new setGoods("0000a90583","150","40","42","nail","59400");
goods[676] =new setGoods("0000a90584","90","45","42","nail","50600");
goods[677] =new setGoods("0000a90585","95","45","42","nail","51700");
goods[678] =new setGoods("0000a90586","100","45","42","nail","52800");
goods[679] =new setGoods("0000a90587","105","45","42","nail","53900");
goods[680] =new setGoods("0000a90588","110","45","42","nail","55000");
goods[681] =new setGoods("0000a90589","115","45","42","nail","56100");
goods[682] =new setGoods("0000a90590","120","45","42","nail","57200");
goods[683] =new setGoods("0000a90591","125","45","42","nail","58300");
goods[684] =new setGoods("0000a90592","130","45","42","nail","59400");
goods[685] =new setGoods("0000a90593","135","45","42","nail","60500");
goods[686] =new setGoods("0000a90594","140","45","42","nail","61600");
goods[687] =new setGoods("0000a90595","145","45","42","nail","62700");
goods[688] =new setGoods("0000a90596","150","45","42","nail","63800");
goods[689] =new setGoods("0000a90597","90","50","42","nail","55000");
goods[690] =new setGoods("0000a90598","95","50","42","nail","56100");
goods[691] =new setGoods("0000a90599","100","50","42","nail","57200");
goods[692] =new setGoods("0000a90600","105","50","42","nail","58300");
goods[693] =new setGoods("0000a90601","110","50","42","nail","59400");
goods[694] =new setGoods("0000a90602","115","50","42","nail","60500");
goods[695] =new setGoods("0000a90603","120","50","42","nail","61600");
goods[696] =new setGoods("0000a90604","125","50","42","nail","62700");
goods[697] =new setGoods("0000a90605","130","50","42","nail","63800");
goods[698] =new setGoods("0000a90606","135","50","42","nail","64900");
goods[699] =new setGoods("0000a90607","140","50","42","nail","66000");
goods[700] =new setGoods("0000a90608","145","50","42","nail","67100");
goods[701] =new setGoods("0000a90609","150","50","42","nail","68200");
goods[702] =new setGoods("0000a90610","90","55","42","nail","59400");
goods[703] =new setGoods("0000a90611","95","55","42","nail","60500");
goods[704] =new setGoods("0000a90612","100","55","42","nail","61600");
goods[705] =new setGoods("0000a90613","105","55","42","nail","62700");
goods[706] =new setGoods("0000a90614","110","55","42","nail","63800");
goods[707] =new setGoods("0000a90615","115","55","42","nail","64900");
goods[708] =new setGoods("0000a90616","120","55","42","nail","66000");
goods[709] =new setGoods("0000a90617","125","55","42","nail","67100");
goods[710] =new setGoods("0000a90618","130","55","42","nail","68200");
goods[711] =new setGoods("0000a90619","135","55","42","nail","69300");
goods[712] =new setGoods("0000a90620","140","55","42","nail","70400");
goods[713] =new setGoods("0000a90621","145","55","42","nail","71500");
goods[714] =new setGoods("0000a90622","150","55","42","nail","72600");
goods[715] =new setGoods("0000a90623","90","60","42","nail","63800");
goods[716] =new setGoods("0000a90624","95","60","42","nail","64900");
goods[717] =new setGoods("0000a90625","100","60","42","nail","66000");
goods[718] =new setGoods("0000a90626","105","60","42","nail","67100");
goods[719] =new setGoods("0000a90627","110","60","42","nail","68200");
goods[720] =new setGoods("0000a90628","115","60","42","nail","69300");
goods[721] =new setGoods("0000a90629","120","60","42","nail","70400");
goods[722] =new setGoods("0000a90630","125","60","42","nail","71500");
goods[723] =new setGoods("0000a90631","130","60","42","nail","72600");
goods[724] =new setGoods("0000a90632","135","60","42","nail","73700");
goods[725] =new setGoods("0000a90633","140","60","42","nail","74800");
goods[726] =new setGoods("0000a90634","145","60","42","nail","75900");
goods[727] =new setGoods("0000a90635","150","60","42","nail","77000");
goods[728] =new setGoods("0000a90636","90","30","50","nail","42900");
goods[729] =new setGoods("0000a90637","95","30","50","nail","44000");
goods[730] =new setGoods("0000a90638","100","30","50","nail","45100");
goods[731] =new setGoods("0000a90639","105","30","50","nail","46200");
goods[732] =new setGoods("0000a90640","110","30","50","nail","47300");
goods[733] =new setGoods("0000a90641","115","30","50","nail","48400");
goods[734] =new setGoods("0000a90642","120","30","50","nail","49500");
goods[735] =new setGoods("0000a90643","125","30","50","nail","50600");
goods[736] =new setGoods("0000a90644","130","30","50","nail","51700");
goods[737] =new setGoods("0000a90645","135","30","50","nail","52800");
goods[738] =new setGoods("0000a90646","140","30","50","nail","53900");
goods[739] =new setGoods("0000a90647","145","30","50","nail","55000");
goods[740] =new setGoods("0000a90648","150","30","50","nail","56100");
goods[741] =new setGoods("0000a90649","90","35","50","nail","47300");
goods[742] =new setGoods("0000a90650","95","35","50","nail","48400");
goods[743] =new setGoods("0000a90651","100","35","50","nail","49500");
goods[744] =new setGoods("0000a90652","105","35","50","nail","50600");
goods[745] =new setGoods("0000a90653","110","35","50","nail","51700");
goods[746] =new setGoods("0000a90654","115","35","50","nail","52800");
goods[747] =new setGoods("0000a90655","120","35","50","nail","53900");
goods[748] =new setGoods("0000a90656","125","35","50","nail","55000");
goods[749] =new setGoods("0000a90657","130","35","50","nail","56100");
goods[750] =new setGoods("0000a90658","135","35","50","nail","57200");
goods[751] =new setGoods("0000a90659","140","35","50","nail","58300");
goods[752] =new setGoods("0000a90660","145","35","50","nail","59400");
goods[753] =new setGoods("0000a90661","150","35","50","nail","60500");
goods[754] =new setGoods("0000a90662","90","40","50","nail","51700");
goods[755] =new setGoods("0000a90663","95","40","50","nail","52800");
goods[756] =new setGoods("0000a90664","100","40","50","nail","53900");
goods[757] =new setGoods("0000a90665","105","40","50","nail","55000");
goods[758] =new setGoods("0000a90666","110","40","50","nail","56100");
goods[759] =new setGoods("0000a90667","115","40","50","nail","57200");
goods[760] =new setGoods("0000a90668","120","40","50","nail","58300");
goods[761] =new setGoods("0000a90669","125","40","50","nail","59400");
goods[762] =new setGoods("0000a90670","130","40","50","nail","60500");
goods[763] =new setGoods("0000a90671","135","40","50","nail","61600");
goods[764] =new setGoods("0000a90672","140","40","50","nail","62700");
goods[765] =new setGoods("0000a90673","145","40","50","nail","63800");
goods[766] =new setGoods("0000a90674","150","40","50","nail","64900");
goods[767] =new setGoods("0000a90675","90","45","50","nail","56100");
goods[768] =new setGoods("0000a90676","95","45","50","nail","57200");
goods[769] =new setGoods("0000a90677","100","45","50","nail","58300");
goods[770] =new setGoods("0000a90678","105","45","50","nail","59400");
goods[771] =new setGoods("0000a90679","110","45","50","nail","60500");
goods[772] =new setGoods("0000a90680","115","45","50","nail","61600");
goods[773] =new setGoods("0000a90681","120","45","50","nail","62700");
goods[774] =new setGoods("0000a90682","125","45","50","nail","63800");
goods[775] =new setGoods("0000a90683","130","45","50","nail","64900");
goods[776] =new setGoods("0000a90684","135","45","50","nail","66000");
goods[777] =new setGoods("0000a90685","140","45","50","nail","67100");
goods[778] =new setGoods("0000a90686","145","45","50","nail","68200");
goods[779] =new setGoods("0000a90687","150","45","50","nail","69300");
goods[780] =new setGoods("0000a90688","90","50","50","nail","60500");
goods[781] =new setGoods("0000a90689","95","50","50","nail","61600");
goods[782] =new setGoods("0000a90690","100","50","50","nail","62700");
goods[783] =new setGoods("0000a90691","105","50","50","nail","63800");
goods[784] =new setGoods("0000a90692","110","50","50","nail","64900");
goods[785] =new setGoods("0000a90693","115","50","50","nail","66000");
goods[786] =new setGoods("0000a90694","120","50","50","nail","67100");
goods[787] =new setGoods("0000a90695","125","50","50","nail","68200");
goods[788] =new setGoods("0000a90696","130","50","50","nail","69300");
goods[789] =new setGoods("0000a90697","135","50","50","nail","70400");
goods[790] =new setGoods("0000a90698","140","50","50","nail","71500");
goods[791] =new setGoods("0000a90699","145","50","50","nail","72600");
goods[792] =new setGoods("0000a90700","150","50","50","nail","73700");
goods[793] =new setGoods("0000a90701","90","55","50","nail","64900");
goods[794] =new setGoods("0000a90702","95","55","50","nail","66000");
goods[795] =new setGoods("0000a90703","100","55","50","nail","67100");
goods[796] =new setGoods("0000a90704","105","55","50","nail","68200");
goods[797] =new setGoods("0000a90705","110","55","50","nail","69300");
goods[798] =new setGoods("0000a90706","115","55","50","nail","70400");
goods[799] =new setGoods("0000a90707","120","55","50","nail","71500");
goods[800] =new setGoods("0000a90708","125","55","50","nail","72600");
goods[801] =new setGoods("0000a90709","130","55","50","nail","73700");
goods[802] =new setGoods("0000a90710","135","55","50","nail","74800");
goods[803] =new setGoods("0000a90711","140","55","50","nail","75900");
goods[804] =new setGoods("0000a90712","145","55","50","nail","77000");
goods[805] =new setGoods("0000a90713","150","55","50","nail","78100");
goods[806] =new setGoods("0000a90714","90","60","50","nail","69300");
goods[807] =new setGoods("0000a90715","95","60","50","nail","70400");
goods[808] =new setGoods("0000a90716","100","60","50","nail","71500");
goods[809] =new setGoods("0000a90717","105","60","50","nail","72600");
goods[810] =new setGoods("0000a90718","110","60","50","nail","73700");
goods[811] =new setGoods("0000a90719","115","60","50","nail","74800");
goods[812] =new setGoods("0000a90720","120","60","50","nail","75900");
goods[813] =new setGoods("0000a90721","125","60","50","nail","77000");
goods[814] =new setGoods("0000a90722","130","60","50","nail","78100");
goods[815] =new setGoods("0000a90723","135","60","50","nail","79200");
goods[816] =new setGoods("0000a90724","140","60","50","nail","80300");
goods[817] =new setGoods("0000a90725","145","60","50","nail","81400");
goods[818] =new setGoods("0000a90726","150","60","50","nail","82500");
goods[819] =new setGoods("0000a90727","90","30","30","black","31900");
goods[820] =new setGoods("0000a90728","95","30","30","black","33000");
goods[821] =new setGoods("0000a90729","100","30","30","black","34100");
goods[822] =new setGoods("0000a90730","105","30","30","black","35200");
goods[823] =new setGoods("0000a90731","110","30","30","black","36300");
goods[824] =new setGoods("0000a90732","115","30","30","black","37400");
goods[825] =new setGoods("0000a90733","120","30","30","black","38500");
goods[826] =new setGoods("0000a90734","125","30","30","black","39600");
goods[827] =new setGoods("0000a90735","130","30","30","black","40700");
goods[828] =new setGoods("0000a90736","135","30","30","black","41800");
goods[829] =new setGoods("0000a90737","140","30","30","black","42900");
goods[830] =new setGoods("0000a90738","145","30","30","black","44000");
goods[831] =new setGoods("0000a90739","150","30","30","black","45100");
goods[832] =new setGoods("0000a90740","90","35","30","black","36300");
goods[833] =new setGoods("0000a90741","95","35","30","black","37400");
goods[834] =new setGoods("0000a90742","100","35","30","black","38500");
goods[835] =new setGoods("0000a90743","105","35","30","black","39600");
goods[836] =new setGoods("0000a90744","110","35","30","black","40700");
goods[837] =new setGoods("0000a90745","115","35","30","black","41800");
goods[838] =new setGoods("0000a90746","120","35","30","black","42900");
goods[839] =new setGoods("0000a90747","125","35","30","black","44000");
goods[840] =new setGoods("0000a90748","130","35","30","black","45100");
goods[841] =new setGoods("0000a90749","135","35","30","black","46200");
goods[842] =new setGoods("0000a90750","140","35","30","black","47300");
goods[843] =new setGoods("0000a90751","145","35","30","black","48400");
goods[844] =new setGoods("0000a90752","150","35","30","black","49500");
goods[845] =new setGoods("0000a90753","90","40","30","black","40700");
goods[846] =new setGoods("0000a90754","95","40","30","black","41800");
goods[847] =new setGoods("0000a90755","100","40","30","black","42900");
goods[848] =new setGoods("0000a90756","105","40","30","black","44000");
goods[849] =new setGoods("0000a90757","110","40","30","black","45100");
goods[850] =new setGoods("0000a90758","115","40","30","black","46200");
goods[851] =new setGoods("0000a90759","120","40","30","black","47300");
goods[852] =new setGoods("0000a90760","125","40","30","black","48400");
goods[853] =new setGoods("0000a90761","130","40","30","black","49500");
goods[854] =new setGoods("0000a90762","135","40","30","black","50600");
goods[855] =new setGoods("0000a90763","140","40","30","black","51700");
goods[856] =new setGoods("0000a90764","145","40","30","black","52800");
goods[857] =new setGoods("0000a90765","150","40","30","black","53900");
goods[858] =new setGoods("0000a90766","90","45","30","black","45100");
goods[859] =new setGoods("0000a90767","95","45","30","black","46200");
goods[860] =new setGoods("0000a90768","100","45","30","black","47300");
goods[861] =new setGoods("0000a90769","105","45","30","black","48400");
goods[862] =new setGoods("0000a90770","110","45","30","black","49500");
goods[863] =new setGoods("0000a90771","115","45","30","black","50600");
goods[864] =new setGoods("0000a90772","120","45","30","black","51700");
goods[865] =new setGoods("0000a90773","125","45","30","black","52800");
goods[866] =new setGoods("0000a90774","130","45","30","black","53900");
goods[867] =new setGoods("0000a90775","135","45","30","black","55000");
goods[868] =new setGoods("0000a90776","140","45","30","black","56100");
goods[869] =new setGoods("0000a90777","145","45","30","black","57200");
goods[870] =new setGoods("0000a90778","150","45","30","black","58300");
goods[871] =new setGoods("0000a90779","90","50","30","black","49500");
goods[872] =new setGoods("0000a90780","95","50","30","black","50600");
goods[873] =new setGoods("0000a90781","100","50","30","black","51700");
goods[874] =new setGoods("0000a90782","105","50","30","black","52800");
goods[875] =new setGoods("0000a90783","110","50","30","black","53900");
goods[876] =new setGoods("0000a90784","115","50","30","black","55000");
goods[877] =new setGoods("0000a90785","120","50","30","black","56100");
goods[878] =new setGoods("0000a90786","125","50","30","black","57200");
goods[879] =new setGoods("0000a90787","130","50","30","black","58300");
goods[880] =new setGoods("0000a90788","135","50","30","black","59400");
goods[881] =new setGoods("0000a90789","140","50","30","black","60500");
goods[882] =new setGoods("0000a90790","145","50","30","black","61600");
goods[883] =new setGoods("0000a90791","150","50","30","black","62700");
goods[884] =new setGoods("0000a90792","90","55","30","black","53900");
goods[885] =new setGoods("0000a90793","95","55","30","black","55000");
goods[886] =new setGoods("0000a90794","100","55","30","black","56100");
goods[887] =new setGoods("0000a90795","105","55","30","black","57200");
goods[888] =new setGoods("0000a90796","110","55","30","black","58300");
goods[889] =new setGoods("0000a90797","115","55","30","black","59400");
goods[890] =new setGoods("0000a90798","120","55","30","black","60500");
goods[891] =new setGoods("0000a90799","125","55","30","black","61600");
goods[892] =new setGoods("0000a90800","130","55","30","black","62700");
goods[893] =new setGoods("0000a90801","135","55","30","black","63800");
goods[894] =new setGoods("0000a90802","140","55","30","black","64900");
goods[895] =new setGoods("0000a90803","145","55","30","black","66000");
goods[896] =new setGoods("0000a90804","150","55","30","black","67100");
goods[897] =new setGoods("0000a90805","90","60","30","black","58300");
goods[898] =new setGoods("0000a90806","95","60","30","black","59400");
goods[899] =new setGoods("0000a90807","100","60","30","black","60500");
goods[900] =new setGoods("0000a90808","105","60","30","black","61600");
goods[901] =new setGoods("0000a90809","110","60","30","black","62700");
goods[902] =new setGoods("0000a90810","115","60","30","black","63800");
goods[903] =new setGoods("0000a90811","120","60","30","black","64900");
goods[904] =new setGoods("0000a90812","125","60","30","black","66000");
goods[905] =new setGoods("0000a90813","130","60","30","black","67100");
goods[906] =new setGoods("0000a90814","135","60","30","black","68200");
goods[907] =new setGoods("0000a90815","140","60","30","black","69300");
goods[908] =new setGoods("0000a90816","145","60","30","black","70400");
goods[909] =new setGoods("0000a90817","150","60","30","black","71500");
goods[910] =new setGoods("0000a90818","90","30","42","black","37400");
goods[911] =new setGoods("0000a90819","95","30","42","black","38500");
goods[912] =new setGoods("0000a90820","100","30","42","black","39600");
goods[913] =new setGoods("0000a90821","105","30","42","black","40700");
goods[914] =new setGoods("0000a90822","110","30","42","black","41800");
goods[915] =new setGoods("0000a90823","115","30","42","black","42900");
goods[916] =new setGoods("0000a90824","120","30","42","black","44000");
goods[917] =new setGoods("0000a90825","125","30","42","black","45100");
goods[918] =new setGoods("0000a90826","130","30","42","black","46200");
goods[919] =new setGoods("0000a90827","135","30","42","black","47300");
goods[920] =new setGoods("0000a90828","140","30","42","black","48400");
goods[921] =new setGoods("0000a90829","145","30","42","black","49500");
goods[922] =new setGoods("0000a90830","150","30","42","black","50600");
goods[923] =new setGoods("0000a90831","90","35","42","black","41800");
goods[924] =new setGoods("0000a90832","95","35","42","black","42900");
goods[925] =new setGoods("0000a90833","100","35","42","black","44000");
goods[926] =new setGoods("0000a90834","105","35","42","black","45100");
goods[927] =new setGoods("0000a90835","110","35","42","black","46200");
goods[928] =new setGoods("0000a90836","115","35","42","black","47300");
goods[929] =new setGoods("0000a90837","120","35","42","black","48400");
goods[930] =new setGoods("0000a90838","125","35","42","black","49500");
goods[931] =new setGoods("0000a90839","130","35","42","black","50600");
goods[932] =new setGoods("0000a90840","135","35","42","black","51700");
goods[933] =new setGoods("0000a90841","140","35","42","black","52800");
goods[934] =new setGoods("0000a90842","145","35","42","black","53900");
goods[935] =new setGoods("0000a90843","150","35","42","black","55000");
goods[936] =new setGoods("0000a90844","90","40","42","black","46200");
goods[937] =new setGoods("0000a90845","95","40","42","black","47300");
goods[938] =new setGoods("0000a90846","100","40","42","black","48400");
goods[939] =new setGoods("0000a90847","105","40","42","black","49500");
goods[940] =new setGoods("0000a90848","110","40","42","black","50600");
goods[941] =new setGoods("0000a90849","115","40","42","black","51700");
goods[942] =new setGoods("0000a90850","120","40","42","black","52800");
goods[943] =new setGoods("0000a90851","125","40","42","black","53900");
goods[944] =new setGoods("0000a90852","130","40","42","black","55000");
goods[945] =new setGoods("0000a90853","135","40","42","black","56100");
goods[946] =new setGoods("0000a90854","140","40","42","black","57200");
goods[947] =new setGoods("0000a90855","145","40","42","black","58300");
goods[948] =new setGoods("0000a90856","150","40","42","black","59400");
goods[949] =new setGoods("0000a90857","90","45","42","black","50600");
goods[950] =new setGoods("0000a90858","95","45","42","black","51700");
goods[951] =new setGoods("0000a90859","100","45","42","black","52800");
goods[952] =new setGoods("0000a90860","105","45","42","black","53900");
goods[953] =new setGoods("0000a90861","110","45","42","black","55000");
goods[954] =new setGoods("0000a90862","115","45","42","black","56100");
goods[955] =new setGoods("0000a90863","120","45","42","black","57200");
goods[956] =new setGoods("0000a90864","125","45","42","black","58300");
goods[957] =new setGoods("0000a90865","130","45","42","black","59400");
goods[958] =new setGoods("0000a90866","135","45","42","black","60500");
goods[959] =new setGoods("0000a90867","140","45","42","black","61600");
goods[960] =new setGoods("0000a90868","145","45","42","black","62700");
goods[961] =new setGoods("0000a90869","150","45","42","black","63800");
goods[962] =new setGoods("0000a90870","90","50","42","black","55000");
goods[963] =new setGoods("0000a90871","95","50","42","black","56100");
goods[964] =new setGoods("0000a90872","100","50","42","black","57200");
goods[965] =new setGoods("0000a90873","105","50","42","black","58300");
goods[966] =new setGoods("0000a90874","110","50","42","black","59400");
goods[967] =new setGoods("0000a90875","115","50","42","black","60500");
goods[968] =new setGoods("0000a90876","120","50","42","black","61600");
goods[969] =new setGoods("0000a90877","125","50","42","black","62700");
goods[970] =new setGoods("0000a90878","130","50","42","black","63800");
goods[971] =new setGoods("0000a90879","135","50","42","black","64900");
goods[972] =new setGoods("0000a90880","140","50","42","black","66000");
goods[973] =new setGoods("0000a90881","145","50","42","black","67100");
goods[974] =new setGoods("0000a90882","150","50","42","black","68200");
goods[975] =new setGoods("0000a90883","90","55","42","black","59400");
goods[976] =new setGoods("0000a90884","95","55","42","black","60500");
goods[977] =new setGoods("0000a90885","100","55","42","black","61600");
goods[978] =new setGoods("0000a90886","105","55","42","black","62700");
goods[979] =new setGoods("0000a90887","110","55","42","black","63800");
goods[980] =new setGoods("0000a90888","115","55","42","black","64900");
goods[981] =new setGoods("0000a90889","120","55","42","black","66000");
goods[982] =new setGoods("0000a90890","125","55","42","black","67100");
goods[983] =new setGoods("0000a90891","130","55","42","black","68200");
goods[984] =new setGoods("0000a90892","135","55","42","black","69300");
goods[985] =new setGoods("0000a90893","140","55","42","black","70400");
goods[986] =new setGoods("0000a90894","145","55","42","black","71500");
goods[987] =new setGoods("0000a90895","150","55","42","black","72600");
goods[988] =new setGoods("0000a90896","90","60","42","black","63800");
goods[989] =new setGoods("0000a90897","95","60","42","black","64900");
goods[990] =new setGoods("0000a90898","100","60","42","black","66000");
goods[991] =new setGoods("0000a90899","105","60","42","black","67100");
goods[992] =new setGoods("0000a90900","110","60","42","black","68200");
goods[993] =new setGoods("0000a90901","115","60","42","black","69300");
goods[994] =new setGoods("0000a90902","120","60","42","black","70400");
goods[995] =new setGoods("0000a90903","125","60","42","black","71500");
goods[996] =new setGoods("0000a90904","130","60","42","black","72600");
goods[997] =new setGoods("0000a90905","135","60","42","black","73700");
goods[998] =new setGoods("0000a90906","140","60","42","black","74800");
goods[999] =new setGoods("0000a90907","145","60","42","black","75900");
goods[1000] =new setGoods("0000a90908","150","60","42","black","77000");
goods[1001] =new setGoods("0000a90909","90","30","50","black","42900");
goods[1002] =new setGoods("0000a90910","95","30","50","black","44000");
goods[1003] =new setGoods("0000a90911","100","30","50","black","45100");
goods[1004] =new setGoods("0000a90912","105","30","50","black","46200");
goods[1005] =new setGoods("0000a90913","110","30","50","black","47300");
goods[1006] =new setGoods("0000a90914","115","30","50","black","48400");
goods[1007] =new setGoods("0000a90915","120","30","50","black","49500");
goods[1008] =new setGoods("0000a90916","125","30","50","black","50600");
goods[1009] =new setGoods("0000a90917","130","30","50","black","51700");
goods[1010] =new setGoods("0000a90918","135","30","50","black","52800");
goods[1011] =new setGoods("0000a90919","140","30","50","black","53900");
goods[1012] =new setGoods("0000a90920","145","30","50","black","55000");
goods[1013] =new setGoods("0000a90921","150","30","50","black","56100");
goods[1014] =new setGoods("0000a90922","90","35","50","black","47300");
goods[1015] =new setGoods("0000a90923","95","35","50","black","48400");
goods[1016] =new setGoods("0000a90924","100","35","50","black","49500");
goods[1017] =new setGoods("0000a90925","105","35","50","black","50600");
goods[1018] =new setGoods("0000a90926","110","35","50","black","51700");
goods[1019] =new setGoods("0000a90927","115","35","50","black","52800");
goods[1020] =new setGoods("0000a90928","120","35","50","black","53900");
goods[1021] =new setGoods("0000a90929","125","35","50","black","55000");
goods[1022] =new setGoods("0000a90930","130","35","50","black","56100");
goods[1023] =new setGoods("0000a90931","135","35","50","black","57200");
goods[1024] =new setGoods("0000a90932","140","35","50","black","58300");
goods[1025] =new setGoods("0000a90933","145","35","50","black","59400");
goods[1026] =new setGoods("0000a90934","150","35","50","black","60500");
goods[1027] =new setGoods("0000a90935","90","40","50","black","51700");
goods[1028] =new setGoods("0000a90936","95","40","50","black","52800");
goods[1029] =new setGoods("0000a90937","100","40","50","black","53900");
goods[1030] =new setGoods("0000a90938","105","40","50","black","55000");
goods[1031] =new setGoods("0000a90939","110","40","50","black","56100");
goods[1032] =new setGoods("0000a90940","115","40","50","black","57200");
goods[1033] =new setGoods("0000a90941","120","40","50","black","58300");
goods[1034] =new setGoods("0000a90942","125","40","50","black","59400");
goods[1035] =new setGoods("0000a90943","130","40","50","black","60500");
goods[1036] =new setGoods("0000a90944","135","40","50","black","61600");
goods[1037] =new setGoods("0000a90945","140","40","50","black","62700");
goods[1038] =new setGoods("0000a90946","145","40","50","black","63800");
goods[1039] =new setGoods("0000a90947","150","40","50","black","64900");
goods[1040] =new setGoods("0000a90948","90","45","50","black","56100");
goods[1041] =new setGoods("0000a90949","95","45","50","black","57200");
goods[1042] =new setGoods("0000a90950","100","45","50","black","58300");
goods[1043] =new setGoods("0000a90951","105","45","50","black","59400");
goods[1044] =new setGoods("0000a90952","110","45","50","black","60500");
goods[1045] =new setGoods("0000a90953","115","45","50","black","61600");
goods[1046] =new setGoods("0000a90954","120","45","50","black","62700");
goods[1047] =new setGoods("0000a90955","125","45","50","black","63800");
goods[1048] =new setGoods("0000a90956","130","45","50","black","64900");
goods[1049] =new setGoods("0000a90957","135","45","50","black","66000");
goods[1050] =new setGoods("0000a90958","140","45","50","black","67100");
goods[1051] =new setGoods("0000a90959","145","45","50","black","68200");
goods[1052] =new setGoods("0000a90960","150","45","50","black","69300");
goods[1053] =new setGoods("0000a90961","90","50","50","black","60500");
goods[1054] =new setGoods("0000a90962","95","50","50","black","61600");
goods[1055] =new setGoods("0000a90963","100","50","50","black","62700");
goods[1056] =new setGoods("0000a90964","105","50","50","black","63800");
goods[1057] =new setGoods("0000a90965","110","50","50","black","64900");
goods[1058] =new setGoods("0000a90966","115","50","50","black","66000");
goods[1059] =new setGoods("0000a90967","120","50","50","black","67100");
goods[1060] =new setGoods("0000a90968","125","50","50","black","68200");
goods[1061] =new setGoods("0000a90969","130","50","50","black","69300");
goods[1062] =new setGoods("0000a90970","135","50","50","black","70400");
goods[1063] =new setGoods("0000a90971","140","50","50","black","71500");
goods[1064] =new setGoods("0000a90972","145","50","50","black","72600");
goods[1065] =new setGoods("0000a90973","150","50","50","black","73700");
goods[1066] =new setGoods("0000a90974","90","55","50","black","64900");
goods[1067] =new setGoods("0000a90975","95","55","50","black","66000");
goods[1068] =new setGoods("0000a90976","100","55","50","black","67100");
goods[1069] =new setGoods("0000a90977","105","55","50","black","68200");
goods[1070] =new setGoods("0000a90978","110","55","50","black","69300");
goods[1071] =new setGoods("0000a90979","115","55","50","black","70400");
goods[1072] =new setGoods("0000a90980","120","55","50","black","71500");
goods[1073] =new setGoods("0000a90981","125","55","50","black","72600");
goods[1074] =new setGoods("0000a90982","130","55","50","black","73700");
goods[1075] =new setGoods("0000a90983","135","55","50","black","74800");
goods[1076] =new setGoods("0000a90984","140","55","50","black","75900");
goods[1077] =new setGoods("0000a90985","145","55","50","black","77000");
goods[1078] =new setGoods("0000a90986","150","55","50","black","78100");
goods[1079] =new setGoods("0000a90987","90","60","50","black","69300");
goods[1080] =new setGoods("0000a90988","95","60","50","black","70400");
goods[1081] =new setGoods("0000a90989","100","60","50","black","71500");
goods[1082] =new setGoods("0000a90990","105","60","50","black","72600");
goods[1083] =new setGoods("0000a90991","110","60","50","black","73700");
goods[1084] =new setGoods("0000a90992","115","60","50","black","74800");
goods[1085] =new setGoods("0000a90993","120","60","50","black","75900");
goods[1086] =new setGoods("0000a90994","125","60","50","black","77000");
goods[1087] =new setGoods("0000a90995","130","60","50","black","78100");
goods[1088] =new setGoods("0000a90996","135","60","50","black","79200");
goods[1089] =new setGoods("0000a90997","140","60","50","black","80300");
goods[1090] =new setGoods("0000a90998","145","60","50","black","81400");
goods[1091] =new setGoods("0000a90999","150","60","50","black","82500");
goods[1092] =new setGoods("0000a91000","90","30","30","bp","34100");
goods[1093] =new setGoods("0000a91001","95","30","30","bp","35200");
goods[1094] =new setGoods("0000a91002","100","30","30","bp","36300");
goods[1095] =new setGoods("0000a91003","105","30","30","bp","37400");
goods[1096] =new setGoods("0000a91004","110","30","30","bp","38500");
goods[1097] =new setGoods("0000a91005","115","30","30","bp","39600");
goods[1098] =new setGoods("0000a91006","120","30","30","bp","40700");
goods[1099] =new setGoods("0000a91007","125","30","30","bp","41800");
goods[1100] =new setGoods("0000a91008","130","30","30","bp","42900");
goods[1101] =new setGoods("0000a91009","135","30","30","bp","44000");
goods[1102] =new setGoods("0000a91010","140","30","30","bp","45100");
goods[1103] =new setGoods("0000a91011","145","30","30","bp","46200");
goods[1104] =new setGoods("0000a91012","150","30","30","bp","47300");
goods[1105] =new setGoods("0000a91013","90","35","30","bp","38500");
goods[1106] =new setGoods("0000a91014","95","35","30","bp","39600");
goods[1107] =new setGoods("0000a91015","100","35","30","bp","40700");
goods[1108] =new setGoods("0000a91016","105","35","30","bp","41800");
goods[1109] =new setGoods("0000a91017","110","35","30","bp","42900");
goods[1110] =new setGoods("0000a91018","115","35","30","bp","44000");
goods[1111] =new setGoods("0000a91019","120","35","30","bp","45100");
goods[1112] =new setGoods("0000a91020","125","35","30","bp","46200");
goods[1113] =new setGoods("0000a91021","130","35","30","bp","47300");
goods[1114] =new setGoods("0000a91022","135","35","30","bp","48400");
goods[1115] =new setGoods("0000a91023","140","35","30","bp","49500");
goods[1116] =new setGoods("0000a91024","145","35","30","bp","50600");
goods[1117] =new setGoods("0000a91025","150","35","30","bp","51700");
goods[1118] =new setGoods("0000a91026","90","40","30","bp","42900");
goods[1119] =new setGoods("0000a91027","95","40","30","bp","44000");
goods[1120] =new setGoods("0000a91028","100","40","30","bp","45100");
goods[1121] =new setGoods("0000a91029","105","40","30","bp","46200");
goods[1122] =new setGoods("0000a91030","110","40","30","bp","47300");
goods[1123] =new setGoods("0000a91031","115","40","30","bp","48400");
goods[1124] =new setGoods("0000a91032","120","40","30","bp","49500");
goods[1125] =new setGoods("0000a91033","125","40","30","bp","50600");
goods[1126] =new setGoods("0000a91034","130","40","30","bp","51700");
goods[1127] =new setGoods("0000a91035","135","40","30","bp","52800");
goods[1128] =new setGoods("0000a91036","140","40","30","bp","53900");
goods[1129] =new setGoods("0000a91037","145","40","30","bp","55000");
goods[1130] =new setGoods("0000a91038","150","40","30","bp","56100");
goods[1131] =new setGoods("0000a91039","90","45","30","bp","47300");
goods[1132] =new setGoods("0000a91040","95","45","30","bp","48400");
goods[1133] =new setGoods("0000a91041","100","45","30","bp","49500");
goods[1134] =new setGoods("0000a91042","105","45","30","bp","50600");
goods[1135] =new setGoods("0000a91043","110","45","30","bp","51700");
goods[1136] =new setGoods("0000a91044","115","45","30","bp","52800");
goods[1137] =new setGoods("0000a91045","120","45","30","bp","53900");
goods[1138] =new setGoods("0000a91046","125","45","30","bp","55000");
goods[1139] =new setGoods("0000a91047","130","45","30","bp","56100");
goods[1140] =new setGoods("0000a91048","135","45","30","bp","57200");
goods[1141] =new setGoods("0000a91049","140","45","30","bp","58300");
goods[1142] =new setGoods("0000a91050","145","45","30","bp","59400");
goods[1143] =new setGoods("0000a91051","150","45","30","bp","60500");
goods[1144] =new setGoods("0000a91052","90","50","30","bp","51700");
goods[1145] =new setGoods("0000a91053","95","50","30","bp","52800");
goods[1146] =new setGoods("0000a91054","100","50","30","bp","53900");
goods[1147] =new setGoods("0000a91055","105","50","30","bp","55000");
goods[1148] =new setGoods("0000a91056","110","50","30","bp","56100");
goods[1149] =new setGoods("0000a91057","115","50","30","bp","57200");
goods[1150] =new setGoods("0000a91058","120","50","30","bp","58300");
goods[1151] =new setGoods("0000a91059","125","50","30","bp","59400");
goods[1152] =new setGoods("0000a91060","130","50","30","bp","60500");
goods[1153] =new setGoods("0000a91061","135","50","30","bp","61600");
goods[1154] =new setGoods("0000a91062","140","50","30","bp","62700");
goods[1155] =new setGoods("0000a91063","145","50","30","bp","63800");
goods[1156] =new setGoods("0000a91064","150","50","30","bp","64900");
goods[1157] =new setGoods("0000a91065","90","55","30","bp","56100");
goods[1158] =new setGoods("0000a91066","95","55","30","bp","57200");
goods[1159] =new setGoods("0000a91067","100","55","30","bp","58300");
goods[1160] =new setGoods("0000a91068","105","55","30","bp","59400");
goods[1161] =new setGoods("0000a91069","110","55","30","bp","60500");
goods[1162] =new setGoods("0000a91070","115","55","30","bp","61600");
goods[1163] =new setGoods("0000a91071","120","55","30","bp","62700");
goods[1164] =new setGoods("0000a91072","125","55","30","bp","63800");
goods[1165] =new setGoods("0000a91073","130","55","30","bp","64900");
goods[1166] =new setGoods("0000a91074","135","55","30","bp","66000");
goods[1167] =new setGoods("0000a91075","140","55","30","bp","67100");
goods[1168] =new setGoods("0000a91076","145","55","30","bp","68200");
goods[1169] =new setGoods("0000a91077","150","55","30","bp","69300");
goods[1170] =new setGoods("0000a91078","90","60","30","bp","60500");
goods[1171] =new setGoods("0000a91079","95","60","30","bp","61600");
goods[1172] =new setGoods("0000a91080","100","60","30","bp","62700");
goods[1173] =new setGoods("0000a91081","105","60","30","bp","63800");
goods[1174] =new setGoods("0000a91082","110","60","30","bp","64900");
goods[1175] =new setGoods("0000a91083","115","60","30","bp","66000");
goods[1176] =new setGoods("0000a91084","120","60","30","bp","67100");
goods[1177] =new setGoods("0000a91085","125","60","30","bp","68200");
goods[1178] =new setGoods("0000a91086","130","60","30","bp","69300");
goods[1179] =new setGoods("0000a91087","135","60","30","bp","70400");
goods[1180] =new setGoods("0000a91088","140","60","30","bp","71500");
goods[1181] =new setGoods("0000a91089","145","60","30","bp","72600");
goods[1182] =new setGoods("0000a91090","150","60","30","bp","73700");
goods[1183] =new setGoods("0000a91091","90","30","42","bp","39600");
goods[1184] =new setGoods("0000a91092","95","30","42","bp","40700");
goods[1185] =new setGoods("0000a91093","100","30","42","bp","41800");
goods[1186] =new setGoods("0000a91094","105","30","42","bp","42900");
goods[1187] =new setGoods("0000a91095","110","30","42","bp","44000");
goods[1188] =new setGoods("0000a91096","115","30","42","bp","45100");
goods[1189] =new setGoods("0000a91097","120","30","42","bp","46200");
goods[1190] =new setGoods("0000a91098","125","30","42","bp","47300");
goods[1191] =new setGoods("0000a91099","130","30","42","bp","48400");
goods[1192] =new setGoods("0000a91100","135","30","42","bp","49500");
goods[1193] =new setGoods("0000a91101","140","30","42","bp","50600");
goods[1194] =new setGoods("0000a91102","145","30","42","bp","51700");
goods[1195] =new setGoods("0000a91103","150","30","42","bp","52800");
goods[1196] =new setGoods("0000a91104","90","35","42","bp","44000");
goods[1197] =new setGoods("0000a91105","95","35","42","bp","45100");
goods[1198] =new setGoods("0000a91106","100","35","42","bp","46200");
goods[1199] =new setGoods("0000a91107","105","35","42","bp","47300");
goods[1200] =new setGoods("0000a91108","110","35","42","bp","48400");
goods[1201] =new setGoods("0000a91109","115","35","42","bp","49500");
goods[1202] =new setGoods("0000a91110","120","35","42","bp","50600");
goods[1203] =new setGoods("0000a91111","125","35","42","bp","51700");
goods[1204] =new setGoods("0000a91112","130","35","42","bp","52800");
goods[1205] =new setGoods("0000a91113","135","35","42","bp","53900");
goods[1206] =new setGoods("0000a91114","140","35","42","bp","55000");
goods[1207] =new setGoods("0000a91115","145","35","42","bp","56100");
goods[1208] =new setGoods("0000a91116","150","35","42","bp","57200");
goods[1209] =new setGoods("0000a91117","90","40","42","bp","48400");
goods[1210] =new setGoods("0000a91118","95","40","42","bp","49500");
goods[1211] =new setGoods("0000a91119","100","40","42","bp","50600");
goods[1212] =new setGoods("0000a91120","105","40","42","bp","51700");
goods[1213] =new setGoods("0000a91121","110","40","42","bp","52800");
goods[1214] =new setGoods("0000a91122","115","40","42","bp","53900");
goods[1215] =new setGoods("0000a91123","120","40","42","bp","55000");
goods[1216] =new setGoods("0000a91124","125","40","42","bp","56100");
goods[1217] =new setGoods("0000a91125","130","40","42","bp","57200");
goods[1218] =new setGoods("0000a91126","135","40","42","bp","58300");
goods[1219] =new setGoods("0000a91127","140","40","42","bp","59400");
goods[1220] =new setGoods("0000a91128","145","40","42","bp","60500");
goods[1221] =new setGoods("0000a91129","150","40","42","bp","61600");
goods[1222] =new setGoods("0000a91130","90","45","42","bp","52800");
goods[1223] =new setGoods("0000a91131","95","45","42","bp","53900");
goods[1224] =new setGoods("0000a91132","100","45","42","bp","55000");
goods[1225] =new setGoods("0000a91133","105","45","42","bp","56100");
goods[1226] =new setGoods("0000a91134","110","45","42","bp","57200");
goods[1227] =new setGoods("0000a91135","115","45","42","bp","58300");
goods[1228] =new setGoods("0000a91136","120","45","42","bp","59400");
goods[1229] =new setGoods("0000a91137","125","45","42","bp","60500");
goods[1230] =new setGoods("0000a91138","130","45","42","bp","61600");
goods[1231] =new setGoods("0000a91139","135","45","42","bp","62700");
goods[1232] =new setGoods("0000a91140","140","45","42","bp","63800");
goods[1233] =new setGoods("0000a91141","145","45","42","bp","64900");
goods[1234] =new setGoods("0000a91142","150","45","42","bp","66000");
goods[1235] =new setGoods("0000a91143","90","50","42","bp","57200");
goods[1236] =new setGoods("0000a91144","95","50","42","bp","58300");
goods[1237] =new setGoods("0000a91145","100","50","42","bp","59400");
goods[1238] =new setGoods("0000a91146","105","50","42","bp","60500");
goods[1239] =new setGoods("0000a91147","110","50","42","bp","61600");
goods[1240] =new setGoods("0000a91148","115","50","42","bp","62700");
goods[1241] =new setGoods("0000a91149","120","50","42","bp","63800");
goods[1242] =new setGoods("0000a91150","125","50","42","bp","64900");
goods[1243] =new setGoods("0000a91151","130","50","42","bp","66000");
goods[1244] =new setGoods("0000a91152","135","50","42","bp","67100");
goods[1245] =new setGoods("0000a91153","140","50","42","bp","68200");
goods[1246] =new setGoods("0000a91154","145","50","42","bp","69300");
goods[1247] =new setGoods("0000a91155","150","50","42","bp","70400");
goods[1248] =new setGoods("0000a91156","90","55","42","bp","61600");
goods[1249] =new setGoods("0000a91157","95","55","42","bp","62700");
goods[1250] =new setGoods("0000a91158","100","55","42","bp","63800");
goods[1251] =new setGoods("0000a91159","105","55","42","bp","64900");
goods[1252] =new setGoods("0000a91160","110","55","42","bp","66000");
goods[1253] =new setGoods("0000a91161","115","55","42","bp","67100");
goods[1254] =new setGoods("0000a91162","120","55","42","bp","68200");
goods[1255] =new setGoods("0000a91163","125","55","42","bp","69300");
goods[1256] =new setGoods("0000a91164","130","55","42","bp","70400");
goods[1257] =new setGoods("0000a91165","135","55","42","bp","71500");
goods[1258] =new setGoods("0000a91166","140","55","42","bp","72600");
goods[1259] =new setGoods("0000a91167","145","55","42","bp","73700");
goods[1260] =new setGoods("0000a91168","150","55","42","bp","74800");
goods[1261] =new setGoods("0000a91169","90","60","42","bp","66000");
goods[1262] =new setGoods("0000a91170","95","60","42","bp","67100");
goods[1263] =new setGoods("0000a91171","100","60","42","bp","68200");
goods[1264] =new setGoods("0000a91172","105","60","42","bp","69300");
goods[1265] =new setGoods("0000a91173","110","60","42","bp","70400");
goods[1266] =new setGoods("0000a91174","115","60","42","bp","71500");
goods[1267] =new setGoods("0000a91175","120","60","42","bp","72600");
goods[1268] =new setGoods("0000a91176","125","60","42","bp","73700");
goods[1269] =new setGoods("0000a91177","130","60","42","bp","74800");
goods[1270] =new setGoods("0000a91178","135","60","42","bp","75900");
goods[1271] =new setGoods("0000a91179","140","60","42","bp","77000");
goods[1272] =new setGoods("0000a91180","145","60","42","bp","78100");
goods[1273] =new setGoods("0000a91181","150","60","42","bp","79200");
goods[1274] =new setGoods("0000a91182","90","30","50","bp","45100");
goods[1275] =new setGoods("0000a91183","95","30","50","bp","46200");
goods[1276] =new setGoods("0000a91184","100","30","50","bp","47300");
goods[1277] =new setGoods("0000a91185","105","30","50","bp","48400");
goods[1278] =new setGoods("0000a91186","110","30","50","bp","49500");
goods[1279] =new setGoods("0000a91187","115","30","50","bp","50600");
goods[1280] =new setGoods("0000a91188","120","30","50","bp","51700");
goods[1281] =new setGoods("0000a91189","125","30","50","bp","52800");
goods[1282] =new setGoods("0000a91190","130","30","50","bp","53900");
goods[1283] =new setGoods("0000a91191","135","30","50","bp","55000");
goods[1284] =new setGoods("0000a91192","140","30","50","bp","56100");
goods[1285] =new setGoods("0000a91193","145","30","50","bp","57200");
goods[1286] =new setGoods("0000a91194","150","30","50","bp","58300");
goods[1287] =new setGoods("0000a91195","90","35","50","bp","49500");
goods[1288] =new setGoods("0000a91196","95","35","50","bp","50600");
goods[1289] =new setGoods("0000a91197","100","35","50","bp","51700");
goods[1290] =new setGoods("0000a91198","105","35","50","bp","52800");
goods[1291] =new setGoods("0000a91199","110","35","50","bp","53900");
goods[1292] =new setGoods("0000a91200","115","35","50","bp","55000");
goods[1293] =new setGoods("0000a91201","120","35","50","bp","56100");
goods[1294] =new setGoods("0000a91202","125","35","50","bp","57200");
goods[1295] =new setGoods("0000a91203","130","35","50","bp","58300");
goods[1296] =new setGoods("0000a91204","135","35","50","bp","59400");
goods[1297] =new setGoods("0000a91205","140","35","50","bp","60500");
goods[1298] =new setGoods("0000a91206","145","35","50","bp","61600");
goods[1299] =new setGoods("0000a91207","150","35","50","bp","62700");
goods[1300] =new setGoods("0000a91208","90","40","50","bp","53900");
goods[1301] =new setGoods("0000a91209","95","40","50","bp","55000");
goods[1302] =new setGoods("0000a91210","100","40","50","bp","56100");
goods[1303] =new setGoods("0000a91211","105","40","50","bp","57200");
goods[1304] =new setGoods("0000a91212","110","40","50","bp","58300");
goods[1305] =new setGoods("0000a91213","115","40","50","bp","59400");
goods[1306] =new setGoods("0000a91214","120","40","50","bp","60500");
goods[1307] =new setGoods("0000a91215","125","40","50","bp","61600");
goods[1308] =new setGoods("0000a91216","130","40","50","bp","62700");
goods[1309] =new setGoods("0000a91217","135","40","50","bp","63800");
goods[1310] =new setGoods("0000a91218","140","40","50","bp","64900");
goods[1311] =new setGoods("0000a91219","145","40","50","bp","66000");
goods[1312] =new setGoods("0000a91220","150","40","50","bp","67100");
goods[1313] =new setGoods("0000a91221","90","45","50","bp","58300");
goods[1314] =new setGoods("0000a91222","95","45","50","bp","59400");
goods[1315] =new setGoods("0000a91223","100","45","50","bp","60500");
goods[1316] =new setGoods("0000a91224","105","45","50","bp","61600");
goods[1317] =new setGoods("0000a91225","110","45","50","bp","62700");
goods[1318] =new setGoods("0000a91226","115","45","50","bp","63800");
goods[1319] =new setGoods("0000a91227","120","45","50","bp","64900");
goods[1320] =new setGoods("0000a91228","125","45","50","bp","66000");
goods[1321] =new setGoods("0000a91229","130","45","50","bp","67100");
goods[1322] =new setGoods("0000a91230","135","45","50","bp","68200");
goods[1323] =new setGoods("0000a91231","140","45","50","bp","69300");
goods[1324] =new setGoods("0000a91232","145","45","50","bp","70400");
goods[1325] =new setGoods("0000a91233","150","45","50","bp","71500");
goods[1326] =new setGoods("0000a91234","90","50","50","bp","62700");
goods[1327] =new setGoods("0000a91235","95","50","50","bp","63800");
goods[1328] =new setGoods("0000a91236","100","50","50","bp","64900");
goods[1329] =new setGoods("0000a91237","105","50","50","bp","66000");
goods[1330] =new setGoods("0000a91238","110","50","50","bp","67100");
goods[1331] =new setGoods("0000a91239","115","50","50","bp","68200");
goods[1332] =new setGoods("0000a91240","120","50","50","bp","69300");
goods[1333] =new setGoods("0000a91241","125","50","50","bp","70400");
goods[1334] =new setGoods("0000a91242","130","50","50","bp","71500");
goods[1335] =new setGoods("0000a91243","135","50","50","bp","72600");
goods[1336] =new setGoods("0000a91244","140","50","50","bp","73700");
goods[1337] =new setGoods("0000a91245","145","50","50","bp","74800");
goods[1338] =new setGoods("0000a91246","150","50","50","bp","75900");
goods[1339] =new setGoods("0000a91247","90","55","50","bp","67100");
goods[1340] =new setGoods("0000a91248","95","55","50","bp","68200");
goods[1341] =new setGoods("0000a91249","100","55","50","bp","69300");
goods[1342] =new setGoods("0000a91250","105","55","50","bp","70400");
goods[1343] =new setGoods("0000a91251","110","55","50","bp","71500");
goods[1344] =new setGoods("0000a91252","115","55","50","bp","72600");
goods[1345] =new setGoods("0000a91253","120","55","50","bp","73700");
goods[1346] =new setGoods("0000a91254","125","55","50","bp","74800");
goods[1347] =new setGoods("0000a91255","130","55","50","bp","75900");
goods[1348] =new setGoods("0000a91256","135","55","50","bp","77000");
goods[1349] =new setGoods("0000a91257","140","55","50","bp","78100");
goods[1350] =new setGoods("0000a91258","145","55","50","bp","79200");
goods[1351] =new setGoods("0000a91259","150","55","50","bp","80300");
goods[1352] =new setGoods("0000a91260","90","60","50","bp","71500");
goods[1353] =new setGoods("0000a91261","95","60","50","bp","72600");
goods[1354] =new setGoods("0000a91262","100","60","50","bp","73700");
goods[1355] =new setGoods("0000a91263","105","60","50","bp","74800");
goods[1356] =new setGoods("0000a91264","110","60","50","bp","75900");
goods[1357] =new setGoods("0000a91265","115","60","50","bp","77000");
goods[1358] =new setGoods("0000a91266","120","60","50","bp","78100");
goods[1359] =new setGoods("0000a91267","125","60","50","bp","79200");
goods[1360] =new setGoods("0000a91268","130","60","50","bp","80300");
goods[1361] =new setGoods("0000a91269","135","60","50","bp","81400");
goods[1362] =new setGoods("0000a91270","140","60","50","bp","82500");
goods[1363] =new setGoods("0000a91271","145","60","50","bp","83600");
goods[1364] =new setGoods("0000a91272","150","60","50","bp","84700");
goods[1365] =new setGoods("0000a91273","90","30","30","mb","46200");
goods[1366] =new setGoods("0000a91274","95","30","30","mb","47300");
goods[1367] =new setGoods("0000a91275","100","30","30","mb","48400");
goods[1368] =new setGoods("0000a91276","105","30","30","mb","49500");
goods[1369] =new setGoods("0000a91277","110","30","30","mb","50600");
goods[1370] =new setGoods("0000a91278","115","30","30","mb","51700");
goods[1371] =new setGoods("0000a91279","120","30","30","mb","52800");
goods[1372] =new setGoods("0000a91280","125","30","30","mb","53900");
goods[1373] =new setGoods("0000a91281","130","30","30","mb","55000");
goods[1374] =new setGoods("0000a91282","135","30","30","mb","56100");
goods[1375] =new setGoods("0000a91283","140","30","30","mb","57200");
goods[1376] =new setGoods("0000a91284","145","30","30","mb","58300");
goods[1377] =new setGoods("0000a91285","150","30","30","mb","59400");
goods[1378] =new setGoods("0000a91286","90","35","30","mb","52800");
goods[1379] =new setGoods("0000a91287","95","35","30","mb","53900");
goods[1380] =new setGoods("0000a91288","100","35","30","mb","55000");
goods[1381] =new setGoods("0000a91289","105","35","30","mb","56100");
goods[1382] =new setGoods("0000a91290","110","35","30","mb","57200");
goods[1383] =new setGoods("0000a91291","115","35","30","mb","58300");
goods[1384] =new setGoods("0000a91292","120","35","30","mb","59400");
goods[1385] =new setGoods("0000a91293","125","35","30","mb","60500");
goods[1386] =new setGoods("0000a91294","130","35","30","mb","61600");
goods[1387] =new setGoods("0000a91295","135","35","30","mb","62700");
goods[1388] =new setGoods("0000a91296","140","35","30","mb","63800");
goods[1389] =new setGoods("0000a91297","145","35","30","mb","64900");
goods[1390] =new setGoods("0000a91298","150","35","30","mb","66000");
goods[1391] =new setGoods("0000a91299","90","40","30","mb","59400");
goods[1392] =new setGoods("0000a91300","95","40","30","mb","60500");
goods[1393] =new setGoods("0000a91301","100","40","30","mb","61600");
goods[1394] =new setGoods("0000a91302","105","40","30","mb","62700");
goods[1395] =new setGoods("0000a91303","110","40","30","mb","63800");
goods[1396] =new setGoods("0000a91304","115","40","30","mb","64900");
goods[1397] =new setGoods("0000a91305","120","40","30","mb","66000");
goods[1398] =new setGoods("0000a91306","125","40","30","mb","67100");
goods[1399] =new setGoods("0000a91307","130","40","30","mb","68200");
goods[1400] =new setGoods("0000a91308","135","40","30","mb","69300");
goods[1401] =new setGoods("0000a91309","140","40","30","mb","70400");
goods[1402] =new setGoods("0000a91310","145","40","30","mb","71500");
goods[1403] =new setGoods("0000a91311","150","40","30","mb","72600");
goods[1404] =new setGoods("0000a91312","90","45","30","mb","66000");
goods[1405] =new setGoods("0000a91313","95","45","30","mb","67100");
goods[1406] =new setGoods("0000a91314","100","45","30","mb","68200");
goods[1407] =new setGoods("0000a91315","105","45","30","mb","69300");
goods[1408] =new setGoods("0000a91316","110","45","30","mb","70400");
goods[1409] =new setGoods("0000a91317","115","45","30","mb","71500");
goods[1410] =new setGoods("0000a91318","120","45","30","mb","72600");
goods[1411] =new setGoods("0000a91319","125","45","30","mb","73700");
goods[1412] =new setGoods("0000a91320","130","45","30","mb","74800");
goods[1413] =new setGoods("0000a91321","135","45","30","mb","75900");
goods[1414] =new setGoods("0000a91322","140","45","30","mb","77000");
goods[1415] =new setGoods("0000a91323","145","45","30","mb","78100");
goods[1416] =new setGoods("0000a91324","150","45","30","mb","79200");
goods[1417] =new setGoods("0000a91325","90","50","30","mb","72600");
goods[1418] =new setGoods("0000a91326","95","50","30","mb","73700");
goods[1419] =new setGoods("0000a91327","100","50","30","mb","74800");
goods[1420] =new setGoods("0000a91328","105","50","30","mb","75900");
goods[1421] =new setGoods("0000a91329","110","50","30","mb","77000");
goods[1422] =new setGoods("0000a91330","115","50","30","mb","78100");
goods[1423] =new setGoods("0000a91331","120","50","30","mb","79200");
goods[1424] =new setGoods("0000a91332","125","50","30","mb","80300");
goods[1425] =new setGoods("0000a91333","130","50","30","mb","81400");
goods[1426] =new setGoods("0000a91334","135","50","30","mb","82500");
goods[1427] =new setGoods("0000a91335","140","50","30","mb","83600");
goods[1428] =new setGoods("0000a91336","145","50","30","mb","84700");
goods[1429] =new setGoods("0000a91337","150","50","30","mb","85800");
goods[1430] =new setGoods("0000a91338","90","55","30","mb","79200");
goods[1431] =new setGoods("0000a91339","95","55","30","mb","80300");
goods[1432] =new setGoods("0000a91340","100","55","30","mb","81400");
goods[1433] =new setGoods("0000a91341","105","55","30","mb","82500");
goods[1434] =new setGoods("0000a91342","110","55","30","mb","83600");
goods[1435] =new setGoods("0000a91343","115","55","30","mb","84700");
goods[1436] =new setGoods("0000a91344","120","55","30","mb","85800");
goods[1437] =new setGoods("0000a91345","125","55","30","mb","86900");
goods[1438] =new setGoods("0000a91346","130","55","30","mb","88000");
goods[1439] =new setGoods("0000a91347","135","55","30","mb","89100");
goods[1440] =new setGoods("0000a91348","140","55","30","mb","90200");
goods[1441] =new setGoods("0000a91349","145","55","30","mb","91300");
goods[1442] =new setGoods("0000a91350","150","55","30","mb","92400");
goods[1443] =new setGoods("0000a91351","90","60","30","mb","85800");
goods[1444] =new setGoods("0000a91352","95","60","30","mb","86900");
goods[1445] =new setGoods("0000a91353","100","60","30","mb","88000");
goods[1446] =new setGoods("0000a91354","105","60","30","mb","89100");
goods[1447] =new setGoods("0000a91355","110","60","30","mb","90200");
goods[1448] =new setGoods("0000a91356","115","60","30","mb","91300");
goods[1449] =new setGoods("0000a91357","120","60","30","mb","92400");
goods[1450] =new setGoods("0000a91358","125","60","30","mb","93500");
goods[1451] =new setGoods("0000a91359","130","60","30","mb","94600");
goods[1452] =new setGoods("0000a91360","135","60","30","mb","95700");
goods[1453] =new setGoods("0000a91361","140","60","30","mb","96800");
goods[1454] =new setGoods("0000a91362","145","60","30","mb","97900");
goods[1455] =new setGoods("0000a91363","150","60","30","mb","99000");
goods[1456] =new setGoods("0000a91364","90","30","42","mb","51700");
goods[1457] =new setGoods("0000a91365","95","30","42","mb","52800");
goods[1458] =new setGoods("0000a91366","100","30","42","mb","53900");
goods[1459] =new setGoods("0000a91367","105","30","42","mb","55000");
goods[1460] =new setGoods("0000a91368","110","30","42","mb","56100");
goods[1461] =new setGoods("0000a91369","115","30","42","mb","57200");
goods[1462] =new setGoods("0000a91370","120","30","42","mb","58300");
goods[1463] =new setGoods("0000a91371","125","30","42","mb","59400");
goods[1464] =new setGoods("0000a91372","130","30","42","mb","60500");
goods[1465] =new setGoods("0000a91373","135","30","42","mb","61600");
goods[1466] =new setGoods("0000a91374","140","30","42","mb","62700");
goods[1467] =new setGoods("0000a91375","145","30","42","mb","63800");
goods[1468] =new setGoods("0000a91376","150","30","42","mb","64900");
goods[1469] =new setGoods("0000a91377","90","35","42","mb","58300");
goods[1470] =new setGoods("0000a91378","95","35","42","mb","59400");
goods[1471] =new setGoods("0000a91379","100","35","42","mb","60500");
goods[1472] =new setGoods("0000a91380","105","35","42","mb","61600");
goods[1473] =new setGoods("0000a91381","110","35","42","mb","62700");
goods[1474] =new setGoods("0000a91382","115","35","42","mb","63800");
goods[1475] =new setGoods("0000a91383","120","35","42","mb","64900");
goods[1476] =new setGoods("0000a91384","125","35","42","mb","66000");
goods[1477] =new setGoods("0000a91385","130","35","42","mb","67100");
goods[1478] =new setGoods("0000a91386","135","35","42","mb","68200");
goods[1479] =new setGoods("0000a91387","140","35","42","mb","69300");
goods[1480] =new setGoods("0000a91388","145","35","42","mb","70400");
goods[1481] =new setGoods("0000a91389","150","35","42","mb","71500");
goods[1482] =new setGoods("0000a91390","90","40","42","mb","64900");
goods[1483] =new setGoods("0000a91391","95","40","42","mb","66000");
goods[1484] =new setGoods("0000a91392","100","40","42","mb","67100");
goods[1485] =new setGoods("0000a91393","105","40","42","mb","68200");
goods[1486] =new setGoods("0000a91394","110","40","42","mb","69300");
goods[1487] =new setGoods("0000a91395","115","40","42","mb","70400");
goods[1488] =new setGoods("0000a91396","120","40","42","mb","71500");
goods[1489] =new setGoods("0000a91397","125","40","42","mb","72600");
goods[1490] =new setGoods("0000a91398","130","40","42","mb","73700");
goods[1491] =new setGoods("0000a91399","135","40","42","mb","74800");
goods[1492] =new setGoods("0000a91400","140","40","42","mb","75900");
goods[1493] =new setGoods("0000a91401","145","40","42","mb","77000");
goods[1494] =new setGoods("0000a91402","150","40","42","mb","78100");
goods[1495] =new setGoods("0000a91403","90","45","42","mb","71500");
goods[1496] =new setGoods("0000a91404","95","45","42","mb","72600");
goods[1497] =new setGoods("0000a91405","100","45","42","mb","73700");
goods[1498] =new setGoods("0000a91406","105","45","42","mb","74800");
goods[1499] =new setGoods("0000a91407","110","45","42","mb","75900");
goods[1500] =new setGoods("0000a91408","115","45","42","mb","77000");
goods[1501] =new setGoods("0000a91409","120","45","42","mb","78100");
goods[1502] =new setGoods("0000a91410","125","45","42","mb","79200");
goods[1503] =new setGoods("0000a91411","130","45","42","mb","80300");
goods[1504] =new setGoods("0000a91412","135","45","42","mb","81400");
goods[1505] =new setGoods("0000a91413","140","45","42","mb","82500");
goods[1506] =new setGoods("0000a91414","145","45","42","mb","83600");
goods[1507] =new setGoods("0000a91415","150","45","42","mb","84700");
goods[1508] =new setGoods("0000a91416","90","50","42","mb","78100");
goods[1509] =new setGoods("0000a91417","95","50","42","mb","79200");
goods[1510] =new setGoods("0000a91418","100","50","42","mb","80300");
goods[1511] =new setGoods("0000a91419","105","50","42","mb","81400");
goods[1512] =new setGoods("0000a91420","110","50","42","mb","82500");
goods[1513] =new setGoods("0000a91421","115","50","42","mb","83600");
goods[1514] =new setGoods("0000a91422","120","50","42","mb","84700");
goods[1515] =new setGoods("0000a91423","125","50","42","mb","85800");
goods[1516] =new setGoods("0000a91424","130","50","42","mb","86900");
goods[1517] =new setGoods("0000a91425","135","50","42","mb","88000");
goods[1518] =new setGoods("0000a91426","140","50","42","mb","89100");
goods[1519] =new setGoods("0000a91427","145","50","42","mb","90200");
goods[1520] =new setGoods("0000a91428","150","50","42","mb","91300");
goods[1521] =new setGoods("0000a91429","90","55","42","mb","84700");
goods[1522] =new setGoods("0000a91430","95","55","42","mb","85800");
goods[1523] =new setGoods("0000a91431","100","55","42","mb","86900");
goods[1524] =new setGoods("0000a91432","105","55","42","mb","88000");
goods[1525] =new setGoods("0000a91433","110","55","42","mb","89100");
goods[1526] =new setGoods("0000a91434","115","55","42","mb","90200");
goods[1527] =new setGoods("0000a91435","120","55","42","mb","91300");
goods[1528] =new setGoods("0000a91436","125","55","42","mb","92400");
goods[1529] =new setGoods("0000a91437","130","55","42","mb","93500");
goods[1530] =new setGoods("0000a91438","135","55","42","mb","94600");
goods[1531] =new setGoods("0000a91439","140","55","42","mb","95700");
goods[1532] =new setGoods("0000a91440","145","55","42","mb","96800");
goods[1533] =new setGoods("0000a91441","150","55","42","mb","97900");
goods[1534] =new setGoods("0000a91442","90","60","42","mb","91300");
goods[1535] =new setGoods("0000a91443","95","60","42","mb","92400");
goods[1536] =new setGoods("0000a91444","100","60","42","mb","93500");
goods[1537] =new setGoods("0000a91445","105","60","42","mb","94600");
goods[1538] =new setGoods("0000a91446","110","60","42","mb","95700");
goods[1539] =new setGoods("0000a91447","115","60","42","mb","96800");
goods[1540] =new setGoods("0000a91448","120","60","42","mb","97900");
goods[1541] =new setGoods("0000a91449","125","60","42","mb","99000");
goods[1542] =new setGoods("0000a91450","130","60","42","mb","100100");
goods[1543] =new setGoods("0000a91451","135","60","42","mb","101200");
goods[1544] =new setGoods("0000a91452","140","60","42","mb","102300");
goods[1545] =new setGoods("0000a91453","145","60","42","mb","103400");
goods[1546] =new setGoods("0000a91454","150","60","42","mb","104500");
goods[1547] =new setGoods("0000a91455","90","30","50","mb","57200");
goods[1548] =new setGoods("0000a91456","95","30","50","mb","58300");
goods[1549] =new setGoods("0000a91457","100","30","50","mb","59400");
goods[1550] =new setGoods("0000a91458","105","30","50","mb","60500");
goods[1551] =new setGoods("0000a91459","110","30","50","mb","61600");
goods[1552] =new setGoods("0000a91460","115","30","50","mb","62700");
goods[1553] =new setGoods("0000a91461","120","30","50","mb","63800");
goods[1554] =new setGoods("0000a91462","125","30","50","mb","64900");
goods[1555] =new setGoods("0000a91463","130","30","50","mb","66000");
goods[1556] =new setGoods("0000a91464","135","30","50","mb","67100");
goods[1557] =new setGoods("0000a91465","140","30","50","mb","68200");
goods[1558] =new setGoods("0000a91466","145","30","50","mb","69300");
goods[1559] =new setGoods("0000a91467","150","30","50","mb","70400");
goods[1560] =new setGoods("0000a91468","90","35","50","mb","63800");
goods[1561] =new setGoods("0000a91469","95","35","50","mb","64900");
goods[1562] =new setGoods("0000a91470","100","35","50","mb","66000");
goods[1563] =new setGoods("0000a91471","105","35","50","mb","67100");
goods[1564] =new setGoods("0000a91472","110","35","50","mb","68200");
goods[1565] =new setGoods("0000a91473","115","35","50","mb","69300");
goods[1566] =new setGoods("0000a91474","120","35","50","mb","70400");
goods[1567] =new setGoods("0000a91475","125","35","50","mb","71500");
goods[1568] =new setGoods("0000a91476","130","35","50","mb","72600");
goods[1569] =new setGoods("0000a91477","135","35","50","mb","73700");
goods[1570] =new setGoods("0000a91478","140","35","50","mb","74800");
goods[1571] =new setGoods("0000a91479","145","35","50","mb","75900");
goods[1572] =new setGoods("0000a91480","150","35","50","mb","77000");
goods[1573] =new setGoods("0000a91481","90","40","50","mb","70400");
goods[1574] =new setGoods("0000a91482","95","40","50","mb","71500");
goods[1575] =new setGoods("0000a91483","100","40","50","mb","72600");
goods[1576] =new setGoods("0000a91484","105","40","50","mb","73700");
goods[1577] =new setGoods("0000a91485","110","40","50","mb","74800");
goods[1578] =new setGoods("0000a91486","115","40","50","mb","75900");
goods[1579] =new setGoods("0000a91487","120","40","50","mb","77000");
goods[1580] =new setGoods("0000a91488","125","40","50","mb","78100");
goods[1581] =new setGoods("0000a91489","130","40","50","mb","79200");
goods[1582] =new setGoods("0000a91490","135","40","50","mb","80300");
goods[1583] =new setGoods("0000a91491","140","40","50","mb","81400");
goods[1584] =new setGoods("0000a91492","145","40","50","mb","82500");
goods[1585] =new setGoods("0000a91493","150","40","50","mb","83600");
goods[1586] =new setGoods("0000a91494","90","45","50","mb","77000");
goods[1587] =new setGoods("0000a91495","95","45","50","mb","78100");
goods[1588] =new setGoods("0000a91496","100","45","50","mb","79200");
goods[1589] =new setGoods("0000a91497","105","45","50","mb","80300");
goods[1590] =new setGoods("0000a91498","110","45","50","mb","81400");
goods[1591] =new setGoods("0000a91499","115","45","50","mb","82500");
goods[1592] =new setGoods("0000a91500","120","45","50","mb","83600");
goods[1593] =new setGoods("0000a91501","125","45","50","mb","84700");
goods[1594] =new setGoods("0000a91502","130","45","50","mb","85800");
goods[1595] =new setGoods("0000a91503","135","45","50","mb","86900");
goods[1596] =new setGoods("0000a91504","140","45","50","mb","88000");
goods[1597] =new setGoods("0000a91505","145","45","50","mb","89100");
goods[1598] =new setGoods("0000a91506","150","45","50","mb","90200");
goods[1599] =new setGoods("0000a91507","90","50","50","mb","83600");
goods[1600] =new setGoods("0000a91508","95","50","50","mb","84700");
goods[1601] =new setGoods("0000a91509","100","50","50","mb","85800");
goods[1602] =new setGoods("0000a91510","105","50","50","mb","86900");
goods[1603] =new setGoods("0000a91511","110","50","50","mb","88000");
goods[1604] =new setGoods("0000a91512","115","50","50","mb","89100");
goods[1605] =new setGoods("0000a91513","120","50","50","mb","90200");
goods[1606] =new setGoods("0000a91514","125","50","50","mb","91300");
goods[1607] =new setGoods("0000a91515","130","50","50","mb","92400");
goods[1608] =new setGoods("0000a91516","135","50","50","mb","93500");
goods[1609] =new setGoods("0000a91517","140","50","50","mb","94600");
goods[1610] =new setGoods("0000a91518","145","50","50","mb","95700");
goods[1611] =new setGoods("0000a91519","150","50","50","mb","96800");
goods[1612] =new setGoods("0000a91520","90","55","50","mb","90200");
goods[1613] =new setGoods("0000a91521","95","55","50","mb","91300");
goods[1614] =new setGoods("0000a91522","100","55","50","mb","92400");
goods[1615] =new setGoods("0000a91523","105","55","50","mb","93500");
goods[1616] =new setGoods("0000a91524","110","55","50","mb","94600");
goods[1617] =new setGoods("0000a91525","115","55","50","mb","95700");
goods[1618] =new setGoods("0000a91526","120","55","50","mb","96800");
goods[1619] =new setGoods("0000a91527","125","55","50","mb","97900");
goods[1620] =new setGoods("0000a91528","130","55","50","mb","99000");
goods[1621] =new setGoods("0000a91529","135","55","50","mb","100100");
goods[1622] =new setGoods("0000a91530","140","55","50","mb","101200");
goods[1623] =new setGoods("0000a91531","145","55","50","mb","102300");
goods[1624] =new setGoods("0000a91532","150","55","50","mb","103400");
goods[1625] =new setGoods("0000a91533","90","60","50","mb","96800");
goods[1626] =new setGoods("0000a91534","95","60","50","mb","97900");
goods[1627] =new setGoods("0000a91535","100","60","50","mb","99000");
goods[1628] =new setGoods("0000a91536","105","60","50","mb","100100");
goods[1629] =new setGoods("0000a91537","110","60","50","mb","101200");
goods[1630] =new setGoods("0000a91538","115","60","50","mb","102300");
goods[1631] =new setGoods("0000a91539","120","60","50","mb","103400");
goods[1632] =new setGoods("0000a91540","125","60","50","mb","104500");
goods[1633] =new setGoods("0000a91541","130","60","50","mb","105600");
goods[1634] =new setGoods("0000a91542","135","60","50","mb","106700");
goods[1635] =new setGoods("0000a91543","140","60","50","mb","107800");
goods[1636] =new setGoods("0000a91544","145","60","50","mb","108900");
goods[1637] =new setGoods("0000a91545","150","60","50","mb","110000");
goods[1638] =new setGoods("0000a91546","90","30","30","gs","46200");
goods[1639] =new setGoods("0000a91547","95","30","30","gs","47300");
goods[1640] =new setGoods("0000a91548","100","30","30","gs","48400");
goods[1641] =new setGoods("0000a91549","105","30","30","gs","49500");
goods[1642] =new setGoods("0000a91550","110","30","30","gs","50600");
goods[1643] =new setGoods("0000a91551","115","30","30","gs","51700");
goods[1644] =new setGoods("0000a91552","120","30","30","gs","52800");
goods[1645] =new setGoods("0000a91553","125","30","30","gs","53900");
goods[1646] =new setGoods("0000a91554","130","30","30","gs","55000");
goods[1647] =new setGoods("0000a91555","135","30","30","gs","56100");
goods[1648] =new setGoods("0000a91556","140","30","30","gs","57200");
goods[1649] =new setGoods("0000a91557","145","30","30","gs","58300");
goods[1650] =new setGoods("0000a91558","150","30","30","gs","59400");
goods[1651] =new setGoods("0000a91559","90","35","30","gs","52800");
goods[1652] =new setGoods("0000a91560","95","35","30","gs","53900");
goods[1653] =new setGoods("0000a91561","100","35","30","gs","55000");
goods[1654] =new setGoods("0000a91562","105","35","30","gs","56100");
goods[1655] =new setGoods("0000a91563","110","35","30","gs","57200");
goods[1656] =new setGoods("0000a91564","115","35","30","gs","58300");
goods[1657] =new setGoods("0000a91565","120","35","30","gs","59400");
goods[1658] =new setGoods("0000a91566","125","35","30","gs","60500");
goods[1659] =new setGoods("0000a91567","130","35","30","gs","61600");
goods[1660] =new setGoods("0000a91568","135","35","30","gs","62700");
goods[1661] =new setGoods("0000a91569","140","35","30","gs","63800");
goods[1662] =new setGoods("0000a91570","145","35","30","gs","64900");
goods[1663] =new setGoods("0000a91571","150","35","30","gs","66000");
goods[1664] =new setGoods("0000a91572","90","40","30","gs","59400");
goods[1665] =new setGoods("0000a91573","95","40","30","gs","60500");
goods[1666] =new setGoods("0000a91574","100","40","30","gs","61600");
goods[1667] =new setGoods("0000a91575","105","40","30","gs","62700");
goods[1668] =new setGoods("0000a91576","110","40","30","gs","63800");
goods[1669] =new setGoods("0000a91577","115","40","30","gs","64900");
goods[1670] =new setGoods("0000a91578","120","40","30","gs","66000");
goods[1671] =new setGoods("0000a91579","125","40","30","gs","67100");
goods[1672] =new setGoods("0000a91580","130","40","30","gs","68200");
goods[1673] =new setGoods("0000a91581","135","40","30","gs","69300");
goods[1674] =new setGoods("0000a91582","140","40","30","gs","70400");
goods[1675] =new setGoods("0000a91583","145","40","30","gs","71500");
goods[1676] =new setGoods("0000a91584","150","40","30","gs","72600");
goods[1677] =new setGoods("0000a91585","90","45","30","gs","66000");
goods[1678] =new setGoods("0000a91586","95","45","30","gs","67100");
goods[1679] =new setGoods("0000a91587","100","45","30","gs","68200");
goods[1680] =new setGoods("0000a91588","105","45","30","gs","69300");
goods[1681] =new setGoods("0000a91589","110","45","30","gs","70400");
goods[1682] =new setGoods("0000a91590","115","45","30","gs","71500");
goods[1683] =new setGoods("0000a91591","120","45","30","gs","72600");
goods[1684] =new setGoods("0000a91592","125","45","30","gs","73700");
goods[1685] =new setGoods("0000a91593","130","45","30","gs","74800");
goods[1686] =new setGoods("0000a91594","135","45","30","gs","75900");
goods[1687] =new setGoods("0000a91595","140","45","30","gs","77000");
goods[1688] =new setGoods("0000a91596","145","45","30","gs","78100");
goods[1689] =new setGoods("0000a91597","150","45","30","gs","79200");
goods[1690] =new setGoods("0000a91598","90","50","30","gs","72600");
goods[1691] =new setGoods("0000a91599","95","50","30","gs","73700");
goods[1692] =new setGoods("0000a91600","100","50","30","gs","74800");
goods[1693] =new setGoods("0000a91601","105","50","30","gs","75900");
goods[1694] =new setGoods("0000a91602","110","50","30","gs","77000");
goods[1695] =new setGoods("0000a91603","115","50","30","gs","78100");
goods[1696] =new setGoods("0000a91604","120","50","30","gs","79200");
goods[1697] =new setGoods("0000a91605","125","50","30","gs","80300");
goods[1698] =new setGoods("0000a91606","130","50","30","gs","81400");
goods[1699] =new setGoods("0000a91607","135","50","30","gs","82500");
goods[1700] =new setGoods("0000a91608","140","50","30","gs","83600");
goods[1701] =new setGoods("0000a91609","145","50","30","gs","84700");
goods[1702] =new setGoods("0000a91610","150","50","30","gs","85800");
goods[1703] =new setGoods("0000a91611","90","55","30","gs","79200");
goods[1704] =new setGoods("0000a91612","95","55","30","gs","80300");
goods[1705] =new setGoods("0000a91613","100","55","30","gs","81400");
goods[1706] =new setGoods("0000a91614","105","55","30","gs","82500");
goods[1707] =new setGoods("0000a91615","110","55","30","gs","83600");
goods[1708] =new setGoods("0000a91616","115","55","30","gs","84700");
goods[1709] =new setGoods("0000a91617","120","55","30","gs","85800");
goods[1710] =new setGoods("0000a91618","125","55","30","gs","86900");
goods[1711] =new setGoods("0000a91619","130","55","30","gs","88000");
goods[1712] =new setGoods("0000a91620","135","55","30","gs","89100");
goods[1713] =new setGoods("0000a91621","140","55","30","gs","90200");
goods[1714] =new setGoods("0000a91622","145","55","30","gs","91300");
goods[1715] =new setGoods("0000a91623","150","55","30","gs","92400");
goods[1716] =new setGoods("0000a91624","90","60","30","gs","85800");
goods[1717] =new setGoods("0000a91625","95","60","30","gs","86900");
goods[1718] =new setGoods("0000a91626","100","60","30","gs","88000");
goods[1719] =new setGoods("0000a91627","105","60","30","gs","89100");
goods[1720] =new setGoods("0000a91628","110","60","30","gs","90200");
goods[1721] =new setGoods("0000a91629","115","60","30","gs","91300");
goods[1722] =new setGoods("0000a91630","120","60","30","gs","92400");
goods[1723] =new setGoods("0000a91631","125","60","30","gs","93500");
goods[1724] =new setGoods("0000a91632","130","60","30","gs","94600");
goods[1725] =new setGoods("0000a91633","135","60","30","gs","95700");
goods[1726] =new setGoods("0000a91634","140","60","30","gs","96800");
goods[1727] =new setGoods("0000a91635","145","60","30","gs","97900");
goods[1728] =new setGoods("0000a91636","150","60","30","gs","99000");
goods[1729] =new setGoods("0000a91637","90","30","42","gs","51700");
goods[1730] =new setGoods("0000a91638","95","30","42","gs","52800");
goods[1731] =new setGoods("0000a91639","100","30","42","gs","53900");
goods[1732] =new setGoods("0000a91640","105","30","42","gs","55000");
goods[1733] =new setGoods("0000a91641","110","30","42","gs","56100");
goods[1734] =new setGoods("0000a91642","115","30","42","gs","57200");
goods[1735] =new setGoods("0000a91643","120","30","42","gs","58300");
goods[1736] =new setGoods("0000a91644","125","30","42","gs","59400");
goods[1737] =new setGoods("0000a91645","130","30","42","gs","60500");
goods[1738] =new setGoods("0000a91646","135","30","42","gs","61600");
goods[1739] =new setGoods("0000a91647","140","30","42","gs","62700");
goods[1740] =new setGoods("0000a91648","145","30","42","gs","63800");
goods[1741] =new setGoods("0000a91649","150","30","42","gs","64900");
goods[1742] =new setGoods("0000a91650","90","35","42","gs","58300");
goods[1743] =new setGoods("0000a91651","95","35","42","gs","59400");
goods[1744] =new setGoods("0000a91652","100","35","42","gs","60500");
goods[1745] =new setGoods("0000a91653","105","35","42","gs","61600");
goods[1746] =new setGoods("0000a91654","110","35","42","gs","62700");
goods[1747] =new setGoods("0000a91655","115","35","42","gs","63800");
goods[1748] =new setGoods("0000a91656","120","35","42","gs","64900");
goods[1749] =new setGoods("0000a91657","125","35","42","gs","66000");
goods[1750] =new setGoods("0000a91658","130","35","42","gs","67100");
goods[1751] =new setGoods("0000a91659","135","35","42","gs","68200");
goods[1752] =new setGoods("0000a91660","140","35","42","gs","69300");
goods[1753] =new setGoods("0000a91661","145","35","42","gs","70400");
goods[1754] =new setGoods("0000a91662","150","35","42","gs","71500");
goods[1755] =new setGoods("0000a91663","90","40","42","gs","64900");
goods[1756] =new setGoods("0000a91664","95","40","42","gs","66000");
goods[1757] =new setGoods("0000a91665","100","40","42","gs","67100");
goods[1758] =new setGoods("0000a91666","105","40","42","gs","68200");
goods[1759] =new setGoods("0000a91667","110","40","42","gs","69300");
goods[1760] =new setGoods("0000a91668","115","40","42","gs","70400");
goods[1761] =new setGoods("0000a91669","120","40","42","gs","71500");
goods[1762] =new setGoods("0000a91670","125","40","42","gs","72600");
goods[1763] =new setGoods("0000a91671","130","40","42","gs","73700");
goods[1764] =new setGoods("0000a91672","135","40","42","gs","74800");
goods[1765] =new setGoods("0000a91673","140","40","42","gs","75900");
goods[1766] =new setGoods("0000a91674","145","40","42","gs","77000");
goods[1767] =new setGoods("0000a91675","150","40","42","gs","78100");
goods[1768] =new setGoods("0000a91676","90","45","42","gs","71500");
goods[1769] =new setGoods("0000a91677","95","45","42","gs","72600");
goods[1770] =new setGoods("0000a91678","100","45","42","gs","73700");
goods[1771] =new setGoods("0000a91679","105","45","42","gs","74800");
goods[1772] =new setGoods("0000a91680","110","45","42","gs","75900");
goods[1773] =new setGoods("0000a91681","115","45","42","gs","77000");
goods[1774] =new setGoods("0000a91682","120","45","42","gs","78100");
goods[1775] =new setGoods("0000a91683","125","45","42","gs","79200");
goods[1776] =new setGoods("0000a91684","130","45","42","gs","80300");
goods[1777] =new setGoods("0000a91685","135","45","42","gs","81400");
goods[1778] =new setGoods("0000a91686","140","45","42","gs","82500");
goods[1779] =new setGoods("0000a91687","145","45","42","gs","83600");
goods[1780] =new setGoods("0000a91688","150","45","42","gs","84700");
goods[1781] =new setGoods("0000a91689","90","50","42","gs","78100");
goods[1782] =new setGoods("0000a91690","95","50","42","gs","79200");
goods[1783] =new setGoods("0000a91691","100","50","42","gs","80300");
goods[1784] =new setGoods("0000a91692","105","50","42","gs","81400");
goods[1785] =new setGoods("0000a91693","110","50","42","gs","82500");
goods[1786] =new setGoods("0000a91694","115","50","42","gs","83600");
goods[1787] =new setGoods("0000a91695","120","50","42","gs","84700");
goods[1788] =new setGoods("0000a91696","125","50","42","gs","85800");
goods[1789] =new setGoods("0000a91697","130","50","42","gs","86900");
goods[1790] =new setGoods("0000a91698","135","50","42","gs","88000");
goods[1791] =new setGoods("0000a91699","140","50","42","gs","89100");
goods[1792] =new setGoods("0000a91700","145","50","42","gs","90200");
goods[1793] =new setGoods("0000a91701","150","50","42","gs","91300");
goods[1794] =new setGoods("0000a91702","90","55","42","gs","84700");
goods[1795] =new setGoods("0000a91703","95","55","42","gs","85800");
goods[1796] =new setGoods("0000a91704","100","55","42","gs","86900");
goods[1797] =new setGoods("0000a91705","105","55","42","gs","88000");
goods[1798] =new setGoods("0000a91706","110","55","42","gs","89100");
goods[1799] =new setGoods("0000a91707","115","55","42","gs","90200");
goods[1800] =new setGoods("0000a91708","120","55","42","gs","91300");
goods[1801] =new setGoods("0000a91709","125","55","42","gs","92400");
goods[1802] =new setGoods("0000a91710","130","55","42","gs","93500");
goods[1803] =new setGoods("0000a91711","135","55","42","gs","94600");
goods[1804] =new setGoods("0000a91712","140","55","42","gs","95700");
goods[1805] =new setGoods("0000a91713","145","55","42","gs","96800");
goods[1806] =new setGoods("0000a91714","150","55","42","gs","97900");
goods[1807] =new setGoods("0000a91715","90","60","42","gs","91300");
goods[1808] =new setGoods("0000a91716","95","60","42","gs","92400");
goods[1809] =new setGoods("0000a91717","100","60","42","gs","93500");
goods[1810] =new setGoods("0000a91718","105","60","42","gs","94600");
goods[1811] =new setGoods("0000a91719","110","60","42","gs","95700");
goods[1812] =new setGoods("0000a91720","115","60","42","gs","96800");
goods[1813] =new setGoods("0000a91721","120","60","42","gs","97900");
goods[1814] =new setGoods("0000a91722","125","60","42","gs","99000");
goods[1815] =new setGoods("0000a91723","130","60","42","gs","100100");
goods[1816] =new setGoods("0000a91724","135","60","42","gs","101200");
goods[1817] =new setGoods("0000a91725","140","60","42","gs","102300");
goods[1818] =new setGoods("0000a91726","145","60","42","gs","103400");
goods[1819] =new setGoods("0000a91727","150","60","42","gs","104500");
goods[1820] =new setGoods("0000a91728","90","30","50","gs","57200");
goods[1821] =new setGoods("0000a91729","95","30","50","gs","58300");
goods[1822] =new setGoods("0000a91730","100","30","50","gs","59400");
goods[1823] =new setGoods("0000a91731","105","30","50","gs","60500");
goods[1824] =new setGoods("0000a91732","110","30","50","gs","61600");
goods[1825] =new setGoods("0000a91733","115","30","50","gs","62700");
goods[1826] =new setGoods("0000a91734","120","30","50","gs","63800");
goods[1827] =new setGoods("0000a91735","125","30","50","gs","64900");
goods[1828] =new setGoods("0000a91736","130","30","50","gs","66000");
goods[1829] =new setGoods("0000a91737","135","30","50","gs","67100");
goods[1830] =new setGoods("0000a91738","140","30","50","gs","68200");
goods[1831] =new setGoods("0000a91739","145","30","50","gs","69300");
goods[1832] =new setGoods("0000a91740","150","30","50","gs","70400");
goods[1833] =new setGoods("0000a91741","90","35","50","gs","63800");
goods[1834] =new setGoods("0000a91742","95","35","50","gs","64900");
goods[1835] =new setGoods("0000a91743","100","35","50","gs","66000");
goods[1836] =new setGoods("0000a91744","105","35","50","gs","67100");
goods[1837] =new setGoods("0000a91745","110","35","50","gs","68200");
goods[1838] =new setGoods("0000a91746","115","35","50","gs","69300");
goods[1839] =new setGoods("0000a91747","120","35","50","gs","70400");
goods[1840] =new setGoods("0000a91748","125","35","50","gs","71500");
goods[1841] =new setGoods("0000a91749","130","35","50","gs","72600");
goods[1842] =new setGoods("0000a91750","135","35","50","gs","73700");
goods[1843] =new setGoods("0000a91751","140","35","50","gs","74800");
goods[1844] =new setGoods("0000a91752","145","35","50","gs","75900");
goods[1845] =new setGoods("0000a91753","150","35","50","gs","77000");
goods[1846] =new setGoods("0000a91754","90","40","50","gs","70400");
goods[1847] =new setGoods("0000a91755","95","40","50","gs","71500");
goods[1848] =new setGoods("0000a91756","100","40","50","gs","72600");
goods[1849] =new setGoods("0000a91757","105","40","50","gs","73700");
goods[1850] =new setGoods("0000a91758","110","40","50","gs","74800");
goods[1851] =new setGoods("0000a91759","115","40","50","gs","75900");
goods[1852] =new setGoods("0000a91760","120","40","50","gs","77000");
goods[1853] =new setGoods("0000a91761","125","40","50","gs","78100");
goods[1854] =new setGoods("0000a91762","130","40","50","gs","79200");
goods[1855] =new setGoods("0000a91763","135","40","50","gs","80300");
goods[1856] =new setGoods("0000a91764","140","40","50","gs","81400");
goods[1857] =new setGoods("0000a91765","145","40","50","gs","82500");
goods[1858] =new setGoods("0000a91766","150","40","50","gs","83600");
goods[1859] =new setGoods("0000a91767","90","45","50","gs","77000");
goods[1860] =new setGoods("0000a91768","95","45","50","gs","78100");
goods[1861] =new setGoods("0000a91769","100","45","50","gs","79200");
goods[1862] =new setGoods("0000a91770","105","45","50","gs","80300");
goods[1863] =new setGoods("0000a91771","110","45","50","gs","81400");
goods[1864] =new setGoods("0000a91772","115","45","50","gs","82500");
goods[1865] =new setGoods("0000a91773","120","45","50","gs","83600");
goods[1866] =new setGoods("0000a91774","125","45","50","gs","84700");
goods[1867] =new setGoods("0000a91775","130","45","50","gs","85800");
goods[1868] =new setGoods("0000a91776","135","45","50","gs","86900");
goods[1869] =new setGoods("0000a91777","140","45","50","gs","88000");
goods[1870] =new setGoods("0000a91778","145","45","50","gs","89100");
goods[1871] =new setGoods("0000a91779","150","45","50","gs","90200");
goods[1872] =new setGoods("0000a91780","90","50","50","gs","83600");
goods[1873] =new setGoods("0000a91781","95","50","50","gs","84700");
goods[1874] =new setGoods("0000a91782","100","50","50","gs","85800");
goods[1875] =new setGoods("0000a91783","105","50","50","gs","86900");
goods[1876] =new setGoods("0000a91784","110","50","50","gs","88000");
goods[1877] =new setGoods("0000a91785","115","50","50","gs","89100");
goods[1878] =new setGoods("0000a91786","120","50","50","gs","90200");
goods[1879] =new setGoods("0000a91787","125","50","50","gs","91300");
goods[1880] =new setGoods("0000a91788","130","50","50","gs","92400");
goods[1881] =new setGoods("0000a91789","135","50","50","gs","93500");
goods[1882] =new setGoods("0000a91790","140","50","50","gs","94600");
goods[1883] =new setGoods("0000a91791","145","50","50","gs","95700");
goods[1884] =new setGoods("0000a91792","150","50","50","gs","96800");
goods[1885] =new setGoods("0000a91793","90","55","50","gs","90200");
goods[1886] =new setGoods("0000a91794","95","55","50","gs","91300");
goods[1887] =new setGoods("0000a91795","100","55","50","gs","92400");
goods[1888] =new setGoods("0000a91796","105","55","50","gs","93500");
goods[1889] =new setGoods("0000a91797","110","55","50","gs","94600");
goods[1890] =new setGoods("0000a91798","115","55","50","gs","95700");
goods[1891] =new setGoods("0000a91799","120","55","50","gs","96800");
goods[1892] =new setGoods("0000a91800","125","55","50","gs","97900");
goods[1893] =new setGoods("0000a91801","130","55","50","gs","99000");
goods[1894] =new setGoods("0000a91802","135","55","50","gs","100100");
goods[1895] =new setGoods("0000a91803","140","55","50","gs","101200");
goods[1896] =new setGoods("0000a91804","145","55","50","gs","102300");
goods[1897] =new setGoods("0000a91805","150","55","50","gs","103400");
goods[1898] =new setGoods("0000a91806","90","60","50","gs","96800");
goods[1899] =new setGoods("0000a91807","95","60","50","gs","97900");
goods[1900] =new setGoods("0000a91808","100","60","50","gs","99000");
goods[1901] =new setGoods("0000a91809","105","60","50","gs","100100");
goods[1902] =new setGoods("0000a91810","110","60","50","gs","101200");
goods[1903] =new setGoods("0000a91811","115","60","50","gs","102300");
goods[1904] =new setGoods("0000a91812","120","60","50","gs","103400");
goods[1905] =new setGoods("0000a91813","125","60","50","gs","104500");
goods[1906] =new setGoods("0000a91814","130","60","50","gs","105600");
goods[1907] =new setGoods("0000a91815","135","60","50","gs","106700");
goods[1908] =new setGoods("0000a91816","140","60","50","gs","107800");
goods[1909] =new setGoods("0000a91817","145","60","50","gs","108900");
goods[1910] =new setGoods("0000a91818","150","60","50","gs","110000");
goods[1911] =new setGoods("0000a91819","90","30","30","ww","46200");
goods[1912] =new setGoods("0000a91820","95","30","30","ww","47300");
goods[1913] =new setGoods("0000a91821","100","30","30","ww","48400");
goods[1914] =new setGoods("0000a91822","105","30","30","ww","49500");
goods[1915] =new setGoods("0000a91823","110","30","30","ww","50600");
goods[1916] =new setGoods("0000a91824","115","30","30","ww","51700");
goods[1917] =new setGoods("0000a91825","120","30","30","ww","52800");
goods[1918] =new setGoods("0000a91826","125","30","30","ww","53900");
goods[1919] =new setGoods("0000a91827","130","30","30","ww","55000");
goods[1920] =new setGoods("0000a91828","135","30","30","ww","56100");
goods[1921] =new setGoods("0000a91829","140","30","30","ww","57200");
goods[1922] =new setGoods("0000a91830","145","30","30","ww","58300");
goods[1923] =new setGoods("0000a91831","150","30","30","ww","59400");
goods[1924] =new setGoods("0000a91832","90","35","30","ww","52800");
goods[1925] =new setGoods("0000a91833","95","35","30","ww","53900");
goods[1926] =new setGoods("0000a91834","100","35","30","ww","55000");
goods[1927] =new setGoods("0000a91835","105","35","30","ww","56100");
goods[1928] =new setGoods("0000a91836","110","35","30","ww","57200");
goods[1929] =new setGoods("0000a91837","115","35","30","ww","58300");
goods[1930] =new setGoods("0000a91838","120","35","30","ww","59400");
goods[1931] =new setGoods("0000a91839","125","35","30","ww","60500");
goods[1932] =new setGoods("0000a91840","130","35","30","ww","61600");
goods[1933] =new setGoods("0000a91841","135","35","30","ww","62700");
goods[1934] =new setGoods("0000a91842","140","35","30","ww","63800");
goods[1935] =new setGoods("0000a91843","145","35","30","ww","64900");
goods[1936] =new setGoods("0000a91844","150","35","30","ww","66000");
goods[1937] =new setGoods("0000a91845","90","40","30","ww","59400");
goods[1938] =new setGoods("0000a91846","95","40","30","ww","60500");
goods[1939] =new setGoods("0000a91847","100","40","30","ww","61600");
goods[1940] =new setGoods("0000a91848","105","40","30","ww","62700");
goods[1941] =new setGoods("0000a91849","110","40","30","ww","63800");
goods[1942] =new setGoods("0000a91850","115","40","30","ww","64900");
goods[1943] =new setGoods("0000a91851","120","40","30","ww","66000");
goods[1944] =new setGoods("0000a91852","125","40","30","ww","67100");
goods[1945] =new setGoods("0000a91853","130","40","30","ww","68200");
goods[1946] =new setGoods("0000a91854","135","40","30","ww","69300");
goods[1947] =new setGoods("0000a91855","140","40","30","ww","70400");
goods[1948] =new setGoods("0000a91856","145","40","30","ww","71500");
goods[1949] =new setGoods("0000a91857","150","40","30","ww","72600");
goods[1950] =new setGoods("0000a91858","90","45","30","ww","66000");
goods[1951] =new setGoods("0000a91859","95","45","30","ww","67100");
goods[1952] =new setGoods("0000a91860","100","45","30","ww","68200");
goods[1953] =new setGoods("0000a91861","105","45","30","ww","69300");
goods[1954] =new setGoods("0000a91862","110","45","30","ww","70400");
goods[1955] =new setGoods("0000a91863","115","45","30","ww","71500");
goods[1956] =new setGoods("0000a91864","120","45","30","ww","72600");
goods[1957] =new setGoods("0000a91865","125","45","30","ww","73700");
goods[1958] =new setGoods("0000a91866","130","45","30","ww","74800");
goods[1959] =new setGoods("0000a91867","135","45","30","ww","75900");
goods[1960] =new setGoods("0000a91868","140","45","30","ww","77000");
goods[1961] =new setGoods("0000a91869","145","45","30","ww","78100");
goods[1962] =new setGoods("0000a91870","150","45","30","ww","79200");
goods[1963] =new setGoods("0000a91871","90","50","30","ww","72600");
goods[1964] =new setGoods("0000a91872","95","50","30","ww","73700");
goods[1965] =new setGoods("0000a91873","100","50","30","ww","74800");
goods[1966] =new setGoods("0000a91874","105","50","30","ww","75900");
goods[1967] =new setGoods("0000a91875","110","50","30","ww","77000");
goods[1968] =new setGoods("0000a91876","115","50","30","ww","78100");
goods[1969] =new setGoods("0000a91877","120","50","30","ww","79200");
goods[1970] =new setGoods("0000a91878","125","50","30","ww","80300");
goods[1971] =new setGoods("0000a91879","130","50","30","ww","81400");
goods[1972] =new setGoods("0000a91880","135","50","30","ww","82500");
goods[1973] =new setGoods("0000a91881","140","50","30","ww","83600");
goods[1974] =new setGoods("0000a91882","145","50","30","ww","84700");
goods[1975] =new setGoods("0000a91883","150","50","30","ww","85800");
goods[1976] =new setGoods("0000a91884","90","55","30","ww","79200");
goods[1977] =new setGoods("0000a91885","95","55","30","ww","80300");
goods[1978] =new setGoods("0000a91886","100","55","30","ww","81400");
goods[1979] =new setGoods("0000a91887","105","55","30","ww","82500");
goods[1980] =new setGoods("0000a91888","110","55","30","ww","83600");
goods[1981] =new setGoods("0000a91889","115","55","30","ww","84700");
goods[1982] =new setGoods("0000a91890","120","55","30","ww","85800");
goods[1983] =new setGoods("0000a91891","125","55","30","ww","86900");
goods[1984] =new setGoods("0000a91892","130","55","30","ww","88000");
goods[1985] =new setGoods("0000a91893","135","55","30","ww","89100");
goods[1986] =new setGoods("0000a91894","140","55","30","ww","90200");
goods[1987] =new setGoods("0000a91895","145","55","30","ww","91300");
goods[1988] =new setGoods("0000a91896","150","55","30","ww","92400");
goods[1989] =new setGoods("0000a91897","90","60","30","ww","85800");
goods[1990] =new setGoods("0000a91898","95","60","30","ww","86900");
goods[1991] =new setGoods("0000a91899","100","60","30","ww","88000");
goods[1992] =new setGoods("0000a91900","105","60","30","ww","89100");
goods[1993] =new setGoods("0000a91901","110","60","30","ww","90200");
goods[1994] =new setGoods("0000a91902","115","60","30","ww","91300");
goods[1995] =new setGoods("0000a91903","120","60","30","ww","92400");
goods[1996] =new setGoods("0000a91904","125","60","30","ww","93500");
goods[1997] =new setGoods("0000a91905","130","60","30","ww","94600");
goods[1998] =new setGoods("0000a91906","135","60","30","ww","95700");
goods[1999] =new setGoods("0000a91907","140","60","30","ww","96800");
goods[2000] =new setGoods("0000a91908","145","60","30","ww","97900");
goods[2001] =new setGoods("0000a91909","150","60","30","ww","99000");
goods[2002] =new setGoods("0000a91910","90","30","42","ww","51700");
goods[2003] =new setGoods("0000a91911","95","30","42","ww","52800");
goods[2004] =new setGoods("0000a91912","100","30","42","ww","53900");
goods[2005] =new setGoods("0000a91913","105","30","42","ww","55000");
goods[2006] =new setGoods("0000a91914","110","30","42","ww","56100");
goods[2007] =new setGoods("0000a91915","115","30","42","ww","57200");
goods[2008] =new setGoods("0000a91916","120","30","42","ww","58300");
goods[2009] =new setGoods("0000a91917","125","30","42","ww","59400");
goods[2010] =new setGoods("0000a91918","130","30","42","ww","60500");
goods[2011] =new setGoods("0000a91919","135","30","42","ww","61600");
goods[2012] =new setGoods("0000a91920","140","30","42","ww","62700");
goods[2013] =new setGoods("0000a91921","145","30","42","ww","63800");
goods[2014] =new setGoods("0000a91922","150","30","42","ww","64900");
goods[2015] =new setGoods("0000a91923","90","35","42","ww","58300");
goods[2016] =new setGoods("0000a91924","95","35","42","ww","59400");
goods[2017] =new setGoods("0000a91925","100","35","42","ww","60500");
goods[2018] =new setGoods("0000a91926","105","35","42","ww","61600");
goods[2019] =new setGoods("0000a91927","110","35","42","ww","62700");
goods[2020] =new setGoods("0000a91928","115","35","42","ww","63800");
goods[2021] =new setGoods("0000a91929","120","35","42","ww","64900");
goods[2022] =new setGoods("0000a91930","125","35","42","ww","66000");
goods[2023] =new setGoods("0000a91931","130","35","42","ww","67100");
goods[2024] =new setGoods("0000a91932","135","35","42","ww","68200");
goods[2025] =new setGoods("0000a91933","140","35","42","ww","69300");
goods[2026] =new setGoods("0000a91934","145","35","42","ww","70400");
goods[2027] =new setGoods("0000a91935","150","35","42","ww","71500");
goods[2028] =new setGoods("0000a91936","90","40","42","ww","64900");
goods[2029] =new setGoods("0000a91937","95","40","42","ww","66000");
goods[2030] =new setGoods("0000a91938","100","40","42","ww","67100");
goods[2031] =new setGoods("0000a91939","105","40","42","ww","68200");
goods[2032] =new setGoods("0000a91940","110","40","42","ww","69300");
goods[2033] =new setGoods("0000a91941","115","40","42","ww","70400");
goods[2034] =new setGoods("0000a91942","120","40","42","ww","71500");
goods[2035] =new setGoods("0000a91943","125","40","42","ww","72600");
goods[2036] =new setGoods("0000a91944","130","40","42","ww","73700");
goods[2037] =new setGoods("0000a91945","135","40","42","ww","74800");
goods[2038] =new setGoods("0000a91946","140","40","42","ww","75900");
goods[2039] =new setGoods("0000a91947","145","40","42","ww","77000");
goods[2040] =new setGoods("0000a91948","150","40","42","ww","78100");
goods[2041] =new setGoods("0000a91949","90","45","42","ww","71500");
goods[2042] =new setGoods("0000a91950","95","45","42","ww","72600");
goods[2043] =new setGoods("0000a91951","100","45","42","ww","73700");
goods[2044] =new setGoods("0000a91952","105","45","42","ww","74800");
goods[2045] =new setGoods("0000a91953","110","45","42","ww","75900");
goods[2046] =new setGoods("0000a91954","115","45","42","ww","77000");
goods[2047] =new setGoods("0000a91955","120","45","42","ww","78100");
goods[2048] =new setGoods("0000a91956","125","45","42","ww","79200");
goods[2049] =new setGoods("0000a91957","130","45","42","ww","80300");
goods[2050] =new setGoods("0000a91958","135","45","42","ww","81400");
goods[2051] =new setGoods("0000a91959","140","45","42","ww","82500");
goods[2052] =new setGoods("0000a91960","145","45","42","ww","83600");
goods[2053] =new setGoods("0000a91961","150","45","42","ww","84700");
goods[2054] =new setGoods("0000a91962","90","50","42","ww","78100");
goods[2055] =new setGoods("0000a91963","95","50","42","ww","79200");
goods[2056] =new setGoods("0000a91964","100","50","42","ww","80300");
goods[2057] =new setGoods("0000a91965","105","50","42","ww","81400");
goods[2058] =new setGoods("0000a91966","110","50","42","ww","82500");
goods[2059] =new setGoods("0000a91967","115","50","42","ww","83600");
goods[2060] =new setGoods("0000a91968","120","50","42","ww","84700");
goods[2061] =new setGoods("0000a91969","125","50","42","ww","85800");
goods[2062] =new setGoods("0000a91970","130","50","42","ww","86900");
goods[2063] =new setGoods("0000a91971","135","50","42","ww","88000");
goods[2064] =new setGoods("0000a91972","140","50","42","ww","89100");
goods[2065] =new setGoods("0000a91973","145","50","42","ww","90200");
goods[2066] =new setGoods("0000a91974","150","50","42","ww","91300");
goods[2067] =new setGoods("0000a91975","90","55","42","ww","84700");
goods[2068] =new setGoods("0000a91976","95","55","42","ww","85800");
goods[2069] =new setGoods("0000a91977","100","55","42","ww","86900");
goods[2070] =new setGoods("0000a91978","105","55","42","ww","88000");
goods[2071] =new setGoods("0000a91979","110","55","42","ww","89100");
goods[2072] =new setGoods("0000a91980","115","55","42","ww","90200");
goods[2073] =new setGoods("0000a91981","120","55","42","ww","91300");
goods[2074] =new setGoods("0000a91982","125","55","42","ww","92400");
goods[2075] =new setGoods("0000a91983","130","55","42","ww","93500");
goods[2076] =new setGoods("0000a91984","135","55","42","ww","94600");
goods[2077] =new setGoods("0000a91985","140","55","42","ww","95700");
goods[2078] =new setGoods("0000a91986","145","55","42","ww","96800");
goods[2079] =new setGoods("0000a91987","150","55","42","ww","97900");
goods[2080] =new setGoods("0000a91988","90","60","42","ww","91300");
goods[2081] =new setGoods("0000a91989","95","60","42","ww","92400");
goods[2082] =new setGoods("0000a91990","100","60","42","ww","93500");
goods[2083] =new setGoods("0000a91991","105","60","42","ww","94600");
goods[2084] =new setGoods("0000a91992","110","60","42","ww","95700");
goods[2085] =new setGoods("0000a91993","115","60","42","ww","96800");
goods[2086] =new setGoods("0000a91994","120","60","42","ww","97900");
goods[2087] =new setGoods("0000a91995","125","60","42","ww","99000");
goods[2088] =new setGoods("0000a91996","130","60","42","ww","100100");
goods[2089] =new setGoods("0000a91997","135","60","42","ww","101200");
goods[2090] =new setGoods("0000a91998","140","60","42","ww","102300");
goods[2091] =new setGoods("0000a91999","145","60","42","ww","103400");
goods[2092] =new setGoods("0000a92000","150","60","42","ww","104500");
goods[2093] =new setGoods("0000a92001","90","30","50","ww","57200");
goods[2094] =new setGoods("0000a92002","95","30","50","ww","58300");
goods[2095] =new setGoods("0000a92003","100","30","50","ww","59400");
goods[2096] =new setGoods("0000a92004","105","30","50","ww","60500");
goods[2097] =new setGoods("0000a92005","110","30","50","ww","61600");
goods[2098] =new setGoods("0000a92006","115","30","50","ww","62700");
goods[2099] =new setGoods("0000a92007","120","30","50","ww","63800");
goods[2100] =new setGoods("0000a92008","125","30","50","ww","64900");
goods[2101] =new setGoods("0000a92009","130","30","50","ww","66000");
goods[2102] =new setGoods("0000a92010","135","30","50","ww","67100");
goods[2103] =new setGoods("0000a92011","140","30","50","ww","68200");
goods[2104] =new setGoods("0000a92012","145","30","50","ww","69300");
goods[2105] =new setGoods("0000a92013","150","30","50","ww","70400");
goods[2106] =new setGoods("0000a92014","90","35","50","ww","63800");
goods[2107] =new setGoods("0000a92015","95","35","50","ww","64900");
goods[2108] =new setGoods("0000a92016","100","35","50","ww","66000");
goods[2109] =new setGoods("0000a92017","105","35","50","ww","67100");
goods[2110] =new setGoods("0000a92018","110","35","50","ww","68200");
goods[2111] =new setGoods("0000a92019","115","35","50","ww","69300");
goods[2112] =new setGoods("0000a92020","120","35","50","ww","70400");
goods[2113] =new setGoods("0000a92021","125","35","50","ww","71500");
goods[2114] =new setGoods("0000a92022","130","35","50","ww","72600");
goods[2115] =new setGoods("0000a92023","135","35","50","ww","73700");
goods[2116] =new setGoods("0000a92024","140","35","50","ww","74800");
goods[2117] =new setGoods("0000a92025","145","35","50","ww","75900");
goods[2118] =new setGoods("0000a92026","150","35","50","ww","77000");
goods[2119] =new setGoods("0000a92027","90","40","50","ww","70400");
goods[2120] =new setGoods("0000a92028","95","40","50","ww","71500");
goods[2121] =new setGoods("0000a92029","100","40","50","ww","72600");
goods[2122] =new setGoods("0000a92030","105","40","50","ww","73700");
goods[2123] =new setGoods("0000a92031","110","40","50","ww","74800");
goods[2124] =new setGoods("0000a92032","115","40","50","ww","75900");
goods[2125] =new setGoods("0000a92033","120","40","50","ww","77000");
goods[2126] =new setGoods("0000a92034","125","40","50","ww","78100");
goods[2127] =new setGoods("0000a92035","130","40","50","ww","79200");
goods[2128] =new setGoods("0000a92036","135","40","50","ww","80300");
goods[2129] =new setGoods("0000a92037","140","40","50","ww","81400");
goods[2130] =new setGoods("0000a92038","145","40","50","ww","82500");
goods[2131] =new setGoods("0000a92039","150","40","50","ww","83600");
goods[2132] =new setGoods("0000a92040","90","45","50","ww","77000");
goods[2133] =new setGoods("0000a92041","95","45","50","ww","78100");
goods[2134] =new setGoods("0000a92042","100","45","50","ww","79200");
goods[2135] =new setGoods("0000a92043","105","45","50","ww","80300");
goods[2136] =new setGoods("0000a92044","110","45","50","ww","81400");
goods[2137] =new setGoods("0000a92045","115","45","50","ww","82500");
goods[2138] =new setGoods("0000a92046","120","45","50","ww","83600");
goods[2139] =new setGoods("0000a92047","125","45","50","ww","84700");
goods[2140] =new setGoods("0000a92048","130","45","50","ww","85800");
goods[2141] =new setGoods("0000a92049","135","45","50","ww","86900");
goods[2142] =new setGoods("0000a92050","140","45","50","ww","88000");
goods[2143] =new setGoods("0000a92051","145","45","50","ww","89100");
goods[2144] =new setGoods("0000a92052","150","45","50","ww","90200");
goods[2145] =new setGoods("0000a92053","90","50","50","ww","83600");
goods[2146] =new setGoods("0000a92054","95","50","50","ww","84700");
goods[2147] =new setGoods("0000a92055","100","50","50","ww","85800");
goods[2148] =new setGoods("0000a92056","105","50","50","ww","86900");
goods[2149] =new setGoods("0000a92057","110","50","50","ww","88000");
goods[2150] =new setGoods("0000a92058","115","50","50","ww","89100");
goods[2151] =new setGoods("0000a92059","120","50","50","ww","90200");
goods[2152] =new setGoods("0000a92060","125","50","50","ww","91300");
goods[2153] =new setGoods("0000a92061","130","50","50","ww","92400");
goods[2154] =new setGoods("0000a92062","135","50","50","ww","93500");
goods[2155] =new setGoods("0000a92063","140","50","50","ww","94600");
goods[2156] =new setGoods("0000a92064","145","50","50","ww","95700");
goods[2157] =new setGoods("0000a92065","150","50","50","ww","96800");
goods[2158] =new setGoods("0000a92066","90","55","50","ww","90200");
goods[2159] =new setGoods("0000a92067","95","55","50","ww","91300");
goods[2160] =new setGoods("0000a92068","100","55","50","ww","92400");
goods[2161] =new setGoods("0000a92069","105","55","50","ww","93500");
goods[2162] =new setGoods("0000a92070","110","55","50","ww","94600");
goods[2163] =new setGoods("0000a92071","115","55","50","ww","95700");
goods[2164] =new setGoods("0000a92072","120","55","50","ww","96800");
goods[2165] =new setGoods("0000a92073","125","55","50","ww","97900");
goods[2166] =new setGoods("0000a92074","130","55","50","ww","99000");
goods[2167] =new setGoods("0000a92075","135","55","50","ww","100100");
goods[2168] =new setGoods("0000a92076","140","55","50","ww","101200");
goods[2169] =new setGoods("0000a92077","145","55","50","ww","102300");
goods[2170] =new setGoods("0000a92078","150","55","50","ww","103400");
goods[2171] =new setGoods("0000a92079","90","60","50","ww","96800");
goods[2172] =new setGoods("0000a92080","95","60","50","ww","97900");
goods[2173] =new setGoods("0000a92081","100","60","50","ww","99000");
goods[2174] =new setGoods("0000a92082","105","60","50","ww","100100");
goods[2175] =new setGoods("0000a92083","110","60","50","ww","101200");
goods[2176] =new setGoods("0000a92084","115","60","50","ww","102300");
goods[2177] =new setGoods("0000a92085","120","60","50","ww","103400");
goods[2178] =new setGoods("0000a92086","125","60","50","ww","104500");
goods[2179] =new setGoods("0000a92087","130","60","50","ww","105600");
goods[2180] =new setGoods("0000a92088","135","60","50","ww","106700");
goods[2181] =new setGoods("0000a92089","140","60","50","ww","107800");
goods[2182] =new setGoods("0000a92090","145","60","50","ww","108900");
goods[2183] =new setGoods("0000a92091","150","60","50","ww","110000");